import React, { useEffect, useMemo, useRef, useState } from "react";
import {
    Table,
    Form,
    Button,
    Col,
    OverlayTrigger,
    Overlay,
    Popover,
    Tooltip,
    Spinner,
} from "react-bootstrap";
import { commonService } from "../../../../utils/commonService";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import { useSelectAPIEndpoint } from "../../../../utils/useSelectAPIEndpoint";
import moment from "moment";
import NoteIcon from "../../../../Assets/Images/CRM/notes.svg";
import darkNoteIcon from "../../../../Assets/Images/CRM/darkNotes.svg";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import Loader from "../../../Loader/Loader";
import DatePicker from "react-datepicker";
import SingleDateSummaryModal from "../../SingleDateSummaryModal";
import SingleDayGroupModal from "../../SingleDayGroupModal";
import { useParams } from "react-router-dom";
import ticket from "../../../../Assets/Images/Revenue-management/tableTicket.svg";

import DemandScore_High from "../../../../Assets/Images/Revenue-management/DemandScore_High.svg";
import DemandScore_Low from "../../../../Assets/Images/Revenue-management/DemandScore_Low.svg";
import DemandScore_Moderate from "../../../../Assets/Images/Revenue-management/DemandScore_Moderate.svg";
import DemandScore_VeryHigh from "../../../../Assets/Images/Revenue-management/DemandScore_VeryHigh.svg";
import DemandScore_VeryLow from "../../../../Assets/Images/Revenue-management/DemandScore_VeryLow.svg";
import saveIcon from "../../../../Assets/Images/Action Icons/saveIcon.svg";
import soldOutIcon from "../../../../Assets/Images/Revenue-management/soldout.svg";

import {
    errorToastMessage,
    successToastMessage,
} from "../../../../utils/toastMessage";
import ToolsSingleTicketPopUp from "../../../CommonComponent/ToolsSingleTicketPopUp";
import { useSelector } from "react-redux";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import WidgetNote from "../../WidgetNote";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import AddWidgetModal from "../../AddWidgetModal";
import emailIcon from "../../../../Assets/Images/Email.svg";
import Comments from "../Comments/Comment";
import { FixColumn } from "../../../../utils/dataTable";
import EventViewModal from "../../../CommonComponent/EventViewModal";
import ToolsSummaryModal from "../../ToolsSummaryModal";
import CustomRangePicker from "../../../CommonComponent/CustomRangePIcker";
import SingleDayPricingForcastModal from "../../SingleDayPricingForcastModal";
import FlagPopup from "../DailySummary/FlagPopup";
import GroupWashChart from "./GroupWashChart";
import Skeleton from "../../../Skeletons/Skeleton";

const getWashClass = (pct) => {
    const numPct = parseFloat(pct);
    if (isNaN(numPct)) return "";
    if (numPct <= 30) return "clear";
    if (numPct <= 60) return "watch";
    if (numPct <= 75) return "warn";
    return "critical";
};

const GroupWash = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const userDetail = commonService.getLoginUserData();
    const stlyComsetRatesEndpoint = useSelectAPIEndpoint({
        standard: API_URL.DAILY_SUMMARY.STLY_LY_COMSET_RATES,
        datewise: API_URL.DAILY_SUMMARY.STLY_LY_COMSET_RATES_DATEWISE,
    });
    const dummyData = [
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
    ];
    let ooo = 0,
        RmsAvailable = 0,
        leftToSell = 0,
        avgleadtime = 0,
        otb = 0,
        occPercentage = 0,
        adr = 0,
        rev = 0,
        revPar = 0,
        groupOTB = 0,
        groupBlock = 0,
        pickupRooms = 0,
        pickupAdr = 0,
        dayName = false,
        barBasedOTB = 0,
        baeBasedRollingAvg = 0,
        pickupAdrCount = 0,
        threePickupRooms = 0,
        threePickupAdr = 0,
        threePickupAdrCount = 0,
        threePickupRev = 0,
        sevenPickupRooms = 0,
        sevenPickupAdr = 0,
        sevenPickupAdrCount = 0,
        pickupRev = 0,
        sevenPickupRev = 0,
        Total_STLY_ADR_Count = 0,
        Total_STLY_ADR = 0,
        Total_STLY_OTB = 0,
        Total_STLY_Revenue = 0,
        Total_STLY_AVG_Lead_Time = 0,
        Total_STLY_AVG_Lead_Time_Count = 0,
        Total_STLY_AVG_Rate = 0,
        Total_LY_ADR_Count = 0,
        Total_LY_ADR = 0,
        Total_LY_OTB = 0,
        Total_LY_Revenue = 0,
        Total_LY_AVG_Lead_Time = 0,
        Total_LY_AVG_Lead_Time_Count = 0,
        Total_LY_AVG_Rate = 0;

    let Total_ActualInventory = 0,
        Total_GRP_Block = 0,
        Total_GRP_Confirm = 0,
        Total_GRP_Avail_Block = 0,
        Total_GRP_Rev = 0,
        Total_GRP_SysWash = 0,
        Total_GRP_UserWash = 0,
        Total_TRA_Rms = 0,
        Total_TRA_Rev = 0,
        Total_AOB_Rms = 0,
        Total_AOB_Rev = 0;

    const initTotalPickup = {
        pick_rms: 0,
        pick_adr: 0,
        pick_rev: 0,
    };
    const { snapshottitle, propertyCode, snapshotId } = useParams();
    const asOfDate = para?.asOfDate || moment().format("YYYY-MM-DD");
    const date = new Date(asOfDate);
    const startDate = commonService.getDateInDBFormat(
        new Date(date.getFullYear(), date.getMonth(), date.getDate()),
    );
    // const endDate = commonService.getDateInDBFormat(
    //   new Date(date.getFullYear(), date.getMonth() + 1, 0),
    // );
    const endDate = commonService.getDateInDBFormat(
        new Date(date.getFullYear(), date.getMonth(), date.getDate() + 14),
    );

    const asOfDateFromRTK = useSelector((store) => store.headerProperty.asOfDate);
    const [orgData, setOrgData] = useState(null);
    const [saveLoading, setSaveLoading] = useState({
        rowId: null,
        loading: false,
    });
    const [loading, setLoading] = useState(true);
    const [chartLoading, setChartLoading] = useState(true);
    const [selectAsOfDate, setSelectAsOfDate] = useState();
    const [startRangeDate, setStartRangeDate] = useState(new Date(startDate));
    const [endRangeDate, setEndRangeDate] = useState(new Date(endDate));
    const [selectPickupDate, setSelectPickupDate] = useState();
    const [selectSevenPickupDate, setSelectSevenPickupDate] = useState();
    const [selectThreePickupDate, setSelectThreePickupDate] = useState();
    const [pickupFromData, setPickupFromData] = useState(null);
    const [pickupFromDataTotal, setPickupFromDataTotal] =
        useState(initTotalPickup);
    const [sevenPickupFromDataTotal, setSevenPickupFromDataTotal] =
        useState(initTotalPickup);
    const [threePickupFromDataTotal, setThreePickupFromDataTotal] =
        useState(initTotalPickup);
    const [sevenPickupFromData, setSevenPickupFromData] = useState(null);
    const [threePickupFromData, setThreePickupFromData] = useState(null);
    const [rateShopListData, setRateShopListData] = useState(null);

    const [past_rateShopListData, setPast_rateShopListData] = useState([]);
    const startRangeDateRef = useRef();
    const endRangeDateRef = useRef();
    const [maxDateForPickupFrom, setMaxDateForPickupFrom] = useState();
    const [showSingleDate, setShowSingleDate] = useState(false);
    const maxDateRef = useRef();
    const sevenMaxDateRef = useRef();
    const threeMaxDateRef = useRef();
    const singleDatePickupDateRef = useRef();
    const singleDateSelectedDateRef = useRef();
    const selectedTdIndexRef = useRef();
    const dateForNoteRef = useRef();
    const userNoteRef = useRef();
    const eventListRef = useRef();
    const eventListPropsRef = useRef();
    const [showTicketModal, setShowTicketModal] = useState(false);
    const [noteUpdate, setNoteUpdate] = useState(false);
    const [noteLoading, setNoteLoading] = useState(false);
    if (maxDateForPickupFrom) {
        let date = new Date(maxDateForPickupFrom);
        let sevenDate = new Date(maxDateForPickupFrom);
        let threeDate = new Date(maxDateForPickupFrom);
        maxDateRef.current = date.setDate(date.getDate() - 1);
        sevenMaxDateRef.current = sevenDate.setDate(sevenDate.getDate() - 7);
        threeMaxDateRef.current = threeDate.setDate(threeDate.getDate() - 3);
    }
    const startDateArrayRef = useRef([]);
    const [forecastData, setForecastData] = useState(null);
    const [forecastLoading, setForecastLoading] = useState(null);

    const [barBasedData, setBarBasedData] = useState(null);
    const [showNoteSidebar, setShowNoteSidebar] = useState(false);
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail,
    );
    const [selectedForecast, setSelectedForecast] = useState(
        propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term
            ? propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term.toLowerCase()
            : "ema",
    );
    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate,
    );
    const [widgetModal, setWidgetModal] = useState(false);
    const [flagModal, setFlagModal] = useState(false);
    const [flagModalData, setFlagModalData] = useState({});
    const widgetDetailRef = useRef();
    const closeWidgetModal = () => {
        setWidgetModal(false);
    };
    const [addNoteModal, setAddNoteModal] = useState(false);
    const closeNoteModal = () => {
        setAddNoteModal(false);
    };
    const [activePresetRange, setActivePresetRange] = useState(null);
    const [openDatePicker, setOpenDatePicker] = useState(false);
    const clickedDateForNote = useRef();
    const [noteDetail, setNoteDetail] = useState(null);
    const selectedEventDateRef = useRef();
    const [showToolsSummaryModal, setToolsSummaryModal] = useState(false);
    const [ClickedDate, setClickedDate] = useState(new Date());

    const closeToolsSummaryModal = () => {
        setToolsSummaryModal(false);
    };

    const handleDateChange = (event) => {
        const [start, end] = event;
        let startSelectedDate = "",
            endSelectedDate = "";
        if (start) {
            let date = new Date(start);
            let month =
                date.getMonth() + 1 > 9
                    ? date.getMonth() + 1
                    : `0${date.getMonth() + 1}`;
            let dateFormat =
                date?.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
            startSelectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
            startRangeDateRef.current = startSelectedDate;
        }
        if (end) {
            let date = new Date(end);
            let month =
                date.getMonth() + 1 > 9
                    ? date.getMonth() + 1
                    : `0${date.getMonth() + 1}`;
            let dateFormat =
                date?.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
            endSelectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
            endRangeDateRef.current = endSelectedDate;
        }

        setStartRangeDate(event[0]);
        setEndRangeDate(event[1]);
        setActivePresetRange(null);
        if (event[0] !== null && event[1] !== null) {
            // let datesArr = commonService.getDateBetweenTwoDates(event[0], event[1]);
            // startDateArrayRef.current = datesArr;
            // callBothApi();
        }
    };

    // const handleApplyRange = (start, end) => {
    //     if (!start || !end) return;

    //     const datesArr = commonService.getDateBetweenTwoDates(
    //         commonService.convertDateInTimezone(start),
    //         commonService.convertDateInTimezone(end)
    //     );

    //     startDateArrayRef.current = datesArr;
    //     callBothApi();
    // };
    const handleApplyRange = (start, end) => {
        if (!start || !end) return;

        // 🔥 Convert to timezone
        const tzStart = commonService.convertDateInTimezone(start);
        const tzEnd = commonService.convertDateInTimezone(end);

        // 🔥 Normalize to DB format
        const normalizedStart = commonService.getDateInDBFormat(tzStart);
        const normalizedEnd = commonService.getDateInDBFormat(tzEnd);

        // 🔥 Store normalized values in refs
        startRangeDateRef.current = normalizedStart;
        endRangeDateRef.current = normalizedEnd;

        // 🔥 Create date array
        const datesArr = commonService.getDateBetweenTwoDates(tzStart, tzEnd);

        startDateArrayRef.current = datesArr;
        callBothApi();
    };

    const htmlToText = (html) => {
        const tempElement = document.createElement("div");
        tempElement.innerHTML = html;
        const plainText = tempElement.innerText;
        return plainText;
    };

    const closeTicketModal = () => {
        setShowTicketModal(false);
    };

    const closeNoteSideBar = () => {
        setShowNoteSidebar(false);
    };
    const diffDayStartDate = new Date(
        commonService.getDateInFormat(
            startRangeDateRef.current ? startRangeDateRef.current : startDate,
        ),
    );
    const diffDayEndDate = new Date(
        commonService.getDateInFormat(
            endRangeDateRef.current ? endRangeDateRef.current : endDate,
        ),
    );
    const diffDayInTime = diffDayEndDate.getTime() - diffDayStartDate.getTime();
    const diffDays = diffDayInTime / (1000 * 3600 * 24);

    const getEventList = async () => {
        let eventList = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.RevenueManagement + API_URL.EVENTS.GET_LIST,
                body: {
                    pageNum: 1,
                    pageSize: 10,
                    sortColumn: "",
                    sortDirection: "asc",
                    searchValue: "",
                    propertyid: parseInt(propertyDetailFromRTK?.propertyid),
                    startdate: null,
                    enddate: null,
                    eventname: "",
                    eventtypeterm: "",
                    yearterm: ``,
                },
            },
            false,
        );

        let eventListResponse = apiResponse(false, eventList);

        if (eventListResponse?.isValidate) {
            let eventListArr = [];

            eventListResponse?.data?.data?.forEach((item) => {
                try {
                    let singleEventObj = {
                        id: item?.eventid ? item?.eventid : 0,
                        name: item?.eventname,
                        detail: item?.eventdetails,
                        startDate: item?.startdate,
                        endDate: item?.enddate,
                        eventJson: item?.eventjson,
                        eventResourceId: item?.eventsourceid,
                    };
                    let eventJsonData = "";
                    if (item?.eventjson) {
                        var decodedString = decodeURIComponent(item?.eventjson);
                        const jsonStringWithoutQuotes = decodedString.slice(1, -1);
                        const jsonStringWithSingleQuotes = `${jsonStringWithoutQuotes}`;
                        eventJsonData = JSON.parse(jsonStringWithSingleQuotes);
                        let desc = eventJsonData?.description?.replaceAll("+", " ");
                        singleEventObj = {
                            ...singleEventObj,
                            labels: eventJsonData?.labels ? eventJsonData?.labels : "",
                            rank: eventJsonData?.rank ? eventJsonData?.rank : 0,
                            local_rank: eventJsonData?.local_rank
                                ? eventJsonData?.local_rank
                                : 0,
                            phq_attendance: eventJsonData?.phq_attendance
                                ? eventJsonData?.phq_attendance
                                : 0,
                            geo_lat: eventJsonData?.geo_lat ? eventJsonData?.geo_lat : "",
                            geo_long: eventJsonData?.geo_long ? eventJsonData?.geo_long : "",
                            detail: desc,
                        };
                    }
                    eventListArr.push(singleEventObj);
                } catch (err) { }
            });
            eventListRef.current = eventListArr;
        }

        if (!eventListResponse?.isValidate) {
            eventListRef.current = [];
        }
    };

    const [FLAG_MECHANISM, setFLAG_MECHANISM] = useState([]);

    const getFLAG_MECHANISM = async () => {
        let startDateMinus = new Date(
            commonService.getDateInDBFormat(
                startRangeDateRef.current ? startRangeDateRef.current : startDate,
            ),
        );
        startDateMinus = new Date(
            startDateMinus.setDate(startDateMinus.getDate() - 2),
        );
        let endDatePlus = new Date(
            commonService.getDateInDBFormat(
                endRangeDateRef.current ? endRangeDateRef.current : endDate,
            ),
        );
        endDatePlus = new Date(endDatePlus.setDate(endDatePlus.getDate() + 2));
        let List = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.FLAG_MECHANISM,
                body: {
                    asofdate: selectAsOfDate ? selectAsOfDate : para?.asOfDate,
                    startdate: commonService.getDateInDBFormat(startDateMinus),
                    enddate: commonService.getDateInDBFormat(endDatePlus),
                    // enddate: endDatePlus,

                    propertyCode: para?.propertyCode,
                },
            },
            false,
        );

        let Response = apiResponse(false, List);

        if (Response?.isValidate) {
            setFLAG_MECHANISM(Response.data.data);
        }

        if (!Response?.isValidate) {
        }
    };

    const getORGDetail = async () => {
        let orgDetailResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.GROUP_WASH.GROUP_WASH_OTB,
                body: {
                    asofdate: selectAsOfDate ? selectAsOfDate : para?.asOfDate,
                    startdate: startRangeDateRef.current
                        ? startRangeDateRef.current
                        : startDate,
                    enddate: endRangeDateRef.current ? endRangeDateRef.current : endDate,
                    propertycode: para?.propertyCode,
                },
            },
            false,
        );

        let response = apiResponse(false, orgDetailResponse);

        if (response?.isValidate) {
            const responseData = response?.data?.data || [];
            setOrgData(responseData);
            if (responseData.length > 0) {
                const receivedDates = new Set(
                    responseData
                        .map((x) => x?.date)
                        .filter(Boolean)
                        .map((d) => moment(d).format("YYYY-MM-DD"))
                );
                startDateArrayRef.current = startDateArrayRef.current.filter((item) => {
                    const formattedItem = moment(item).format("YYYY-MM-DD");
                    return receivedDates.has(formattedItem);
                });
            } else {
                startDateArrayRef.current = [];
            }
        }

        if (!response?.isValidate) {
            setOrgData(dummyData);
        }
    };

    const getPickupFromData = async () => {
        setChartLoading(true);
        let pickupDate = new Date(para?.asOfDate);
        pickupDate.setDate(pickupDate.getDate() - 1);
        singleDatePickupDateRef.current = pickupDate;
        let pickupFromDataResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.GROUP_WASH.GROUP_WASH_PICKUP,
                body: {
                    asofdate: selectAsOfDate ? selectAsOfDate : para?.asOfDate,
                    startdate: startRangeDateRef.current
                        ? startRangeDateRef.current
                        : startDate,
                    enddate: endRangeDateRef.current ? endRangeDateRef.current : endDate,
                    pickupDate: selectPickupDate
                        ? moment(selectPickupDate).format("YYYY-MM-DD")
                        : moment(pickupDate).format("YYYY-MM-DD"),
                    propertycode: para?.propertyCode,
                },
            },
            false,
        );

        let response = apiResponse(false, pickupFromDataResponse);

        if (response?.isValidate) {
            let pickupFromData = response?.data?.data?.data?.map((item, index) => {
                // let dateForTd = new Date(
                //   startDateFromParent ? startDateFromParent : startDate
                // );
                // item.date = commonService.getDateInDBFormat(
                //   dateForTd.setDate(dateForTd.getDate() + index)
                // );

                let dateForTd = startRangeDate
                    ? new Date(startRangeDate)
                    : new Date(startDate);
                item.date = commonService.getDateInDBFormat(
                    dateForTd.setDate(dateForTd.getDate() + index),
                );
                return item;
            });
            setPickupFromDataTotal(response?.data?.data?.total_pickup?.[0]);
            setPickupFromData(pickupFromData);
        }

        if (!response?.isValidate) {
            setPickupFromDataTotal(initTotalPickup);
            setPickupFromData(null);
        }
    };

    const [STLY_LY_COMSET_Rates, setSTLY_LY_COMSET_Rates] = useState(null);

    const getsetSTLY_LY_COMSET_Rates = async () => {
        setLoading(true);
        let pickupDate = new Date(para?.asOfDate);
        pickupDate.setDate(pickupDate.getDate() - 1);
        singleDatePickupDateRef.current = pickupDate;
        let ComsetRatesResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + stlyComsetRatesEndpoint,
                body: {
                    AsOfDate: selectAsOfDate ? selectAsOfDate : para?.asOfDate,
                    startDate: startRangeDateRef.current
                        ? startRangeDateRef.current
                        : startDate,
                    endDate: endRangeDateRef.current ? endRangeDateRef.current : endDate,
                    propertyCode: para?.propertyCode,
                },
            },
            false,
        );

        let response = apiResponse(false, ComsetRatesResponse);

        if (response?.isValidate) {
            setSTLY_LY_COMSET_Rates(response?.data?.data);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setLoading(false);
            setSTLY_LY_COMSET_Rates(null);
        }
    };

    const getSevenPickupFromData = async () => {
        let pickupDate = new Date(para?.asOfDate);
        pickupDate.setDate(pickupDate.getDate() - 7);
        let pickupFromDataResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.GROUP_WASH.GROUP_WASH_PICKUP,
                body: {
                    asofdate: selectAsOfDate ? selectAsOfDate : para?.asOfDate,
                    startdate: startRangeDateRef.current
                        ? startRangeDateRef.current
                        : startDate,
                    enddate: endRangeDateRef.current ? endRangeDateRef.current : endDate,
                    pickupDate: selectSevenPickupDate
                        ? moment(selectSevenPickupDate).format("YYYY-MM-DD")
                        : moment(pickupDate).format("YYYY-MM-DD"),
                    propertycode: para?.propertyCode,
                },
            },
            false,
        );

        let response = apiResponse(false, pickupFromDataResponse);

        if (response?.isValidate) {
            let pickupFromData = response?.data?.data?.data?.map((item, index) => {
                let dateForTd = startRangeDate
                    ? new Date(startRangeDate)
                    : new Date(startDate);
                item.date = commonService.getDateInDBFormat(
                    dateForTd.setDate(dateForTd.getDate() + index),
                );
                return item;
            });

            setSevenPickupFromDataTotal(response?.data?.data?.total_pickup?.[0]);
            setSevenPickupFromData(pickupFromData);
        }

        if (!response?.isValidate) {
            setSevenPickupFromDataTotal(initTotalPickup);
            setSevenPickupFromData(null);
        }
    };

    const getThreePickupFromData = async () => {
        let pickupDate = new Date(para?.asOfDate);
        pickupDate.setDate(pickupDate.getDate() - 3);
        let pickupFromDataResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.GROUP_WASH.GROUP_WASH_PICKUP,
                body: {
                    asofdate: selectAsOfDate ? selectAsOfDate : para?.asOfDate,
                    startdate: startRangeDateRef.current
                        ? startRangeDateRef.current
                        : startDate,
                    enddate: endRangeDateRef.current ? endRangeDateRef.current : endDate,
                    pickupDate: selectThreePickupDate
                        ? moment(selectThreePickupDate).format("YYYY-MM-DD")
                        : moment(pickupDate).format("YYYY-MM-DD"),
                    propertycode: para?.propertyCode,
                },
            },
            false,
        );

        let response = apiResponse(false, pickupFromDataResponse);

        if (response?.isValidate) {
            let pickupFromData = response?.data?.data?.data?.map((item, index) => {
                let dateForTd = startRangeDate
                    ? new Date(startRangeDate)
                    : new Date(startDate);
                item.date = commonService.getDateInDBFormat(
                    dateForTd.setDate(dateForTd.getDate() + index),
                );
                return item;
            });
            setThreePickupFromDataTotal(response?.data?.data?.total_pickup?.[0]);
            setThreePickupFromData(pickupFromData);
        }

        if (!response?.isValidate) {
            setThreePickupFromDataTotal(initTotalPickup);
            setThreePickupFromData(null);
        }
    };

    const rateShopListAsOfDate = async () => {
        setLoading(true);

        let byPropertyIdResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.REVENUE_RATE_SHOP_CONFIG.GET_BY_PROPERTY_ID,
                body: {
                    id: propertyDetailFromRTK?.propertyid,
                },
            },
            false,
        );

        let propertyResponse = apiResponse(false, byPropertyIdResponse);

        let CompareDate = new Date(
            selectAsOfDate ? selectAsOfDate : para?.asOfDate,
        );
        CompareDate = CompareDate.setDate(CompareDate.getDate() - 1);

        let rateShopListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.RATESHOP_LIST,
                body: {
                    AsOfDate: selectAsOfDate ? selectAsOfDate : para?.asOfDate,
                    propertyCode: para?.propertyCode,
                    Channel: propertyResponse?.data?.data?.channel_term
                        ? propertyResponse?.data?.data?.channel_term
                        : "",
                    startDate: startRangeDateRef.current
                        ? startRangeDateRef.current
                        : startDate,
                    endDate: endRangeDateRef.current ? endRangeDateRef.current : endDate,
                    propertyid: propertyDetailFromRTK?.propertyid,
                    CompareDate: CompareDate
                        ? commonService.getDateInDBFormat(CompareDate)
                        : "",
                },
            },
            false,
        );

        let response = apiResponse(false, rateShopListResponse);
        if (response?.isValidate) {
            let rateShopData = response?.data?.data?.map((item, index) => {
                let dateForTd = startRangeDate
                    ? new Date(startRangeDate)
                    : new Date(startDate);
                item.date = commonService.getDateInDBFormat(
                    dateForTd.setDate(dateForTd.getDate() + index),
                );
                return item;
            });

            let distinctData = [];

            rateShopData.forEach((item) => {
                let existing = distinctData.find(
                    (x) =>
                        x.CompetitorID === item.CompetitorID &&
                        x.CheckInDate === item.CheckInDate,
                );

                if (!existing) {
                    distinctData.push({ ...item });
                } else {
                    existing.Rate = Math.min(
                        parseFloat(existing.Rate),
                        parseFloat(item.Rate),
                    ).toFixed(2);
                    existing.PrevRate = Math.min(
                        parseFloat(existing.PrevRate),
                        parseFloat(item.PrevRate),
                    ).toFixed(2);
                    existing.RateDifference = Math.min(
                        parseFloat(existing.RateDifference),
                        parseFloat(item.RateDifference),
                    ).toFixed(2);
                }
            });

            setRateShopListData(distinctData);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setRateShopListData(null);
            setLoading(false);
        }
    };

    const [propertyChannel, setpropertyChannel] = useState("");

    const past_rateShopListAsOfDate = async () => {
        setLoading(true);

        let byPropertyIdResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.REVENUE_RATE_SHOP_CONFIG.GET_BY_PROPERTY_ID,
                body: {
                    id: propertyDetailFromRTK?.propertyid,
                },
            },
            false,
        );

        let propertyResponse = apiResponse(false, byPropertyIdResponse);
        let PevAsOfDate = new Date(
            selectAsOfDate ? selectAsOfDate : para?.asOfDate,
        );
        PevAsOfDate = new Date(date.setDate(PevAsOfDate.getDate() - 1));
        setpropertyChannel(
            propertyResponse?.data?.data?.channel_term
                ? propertyResponse?.data?.data?.channel_term
                : "",
        );
        let rateShopListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.DAILY_SUMMARY.PAST_RATESHOP_LIST,
                body: {
                    AsOfDate: commonService.getDateForNode(PevAsOfDate),
                    propertyCode: para?.propertyCode,
                    Channel: propertyResponse?.data?.data?.channel_term
                        ? propertyResponse?.data?.data?.channel_term
                        : "",
                    startDate: startRangeDateRef.current
                        ? startRangeDateRef.current
                        : startDate,
                    endDate: endRangeDateRef.current ? endRangeDateRef.current : endDate,
                    propertyid: propertyDetailFromRTK?.propertyid,
                },
            },
            false,
        );

        let response = apiResponse(false, rateShopListResponse);
        if (response?.isValidate) {
            let rateShopData = response?.data?.data?.map((item, index) => {
                let dateForTd = startRangeDate
                    ? new Date(startRangeDate)
                    : new Date(startDate);
                item.date = commonService.getDateInDBFormat(
                    dateForTd.setDate(dateForTd.getDate() + index),
                );
                return item;
            });
            setPast_rateShopListData(rateShopData);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setPast_rateShopListData([]);
            setLoading(false);
        }
    };

    const saveNote = async () => {
        let saveResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.SAVE_UPDATE,
                body: {
                    propertyCode: para?.propertyCode,
                    Dates: dateForNoteRef.current,
                    UserNotes: userNoteRef.current,
                },
            },
            false,
        );

        let response = apiResponse(true, saveResponse, setNoteLoading);

        if (response?.isValidate) {
            // successToastMessage(response?.data?.message);
            // setNoteUpdate(!noteUpdate);
        }
        if (!response?.isValidate) {
            errorToastMessage(response?.data?.message);
            // setNoteUpdate(!noteUpdate);
        }
    };

    const getForecastDetail = async () => {
        setForecastLoading(true);
        let forecastResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.DAILY_SUMMARY.PRICING_FORECAST,
                body: {
                    AsOfDate: selectAsOfDate ? selectAsOfDate : para?.asOfDate,
                    startDate: startRangeDateRef.current
                        ? startRangeDateRef.current
                        : startDate,
                    endDate: endRangeDateRef.current ? endRangeDateRef.current : endDate,
                    propertyCode: para?.propertyCode,
                    propertyid: para?.propertyDetail?.propertyid,
                    ForcastType: (selectedForecast
                        ? selectedForecast
                        : "ema"
                    ).toLowerCase(),
                },
            },
            false,
        );

        let response = apiResponse(false, forecastResponse);

        if (response?.isValidate) {
            setForecastData(response?.data?.data);
            setForecastLoading(false);
        }

        if (!response?.isValidate) {
            setForecastData([]);
            setForecastLoading(false);
        }
    };

    const getBarBasedDetail = async () => {
        let barBasedResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.BAR_BASED_STATS,
                body: {
                    AsOfDate: selectAsOfDate ? selectAsOfDate : para?.asOfDate,
                    startDate: startRangeDateRef.current
                        ? startRangeDateRef.current
                        : startDate,
                    endDate: endRangeDateRef.current ? endRangeDateRef.current : endDate,
                    propertyCode: para?.propertyCode,
                },
            },
            false,
        );

        let response = apiResponse(false, barBasedResponse);

        if (response?.isValidate) {
            setBarBasedData(response?.data?.data);
        }
        if (!response?.isValidate) {
            setBarBasedData(null);
        }
    };

    const getNoteByDataList = async () => {
        let noteByDataListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.Configuration +
                    API_URL.WIDGET_NOTE.GET_BY_DATA_LIST,
                body: {
                    propertyid: propertyDetailFromRTK?.propertyid,
                    // widgetid: para?.widgetId,
                    widgetid: 0,
                    startdate: startRangeDateRef.current
                        ? commonService.getDateInDBFormat(startRangeDateRef.current)
                        : commonService.getDateInDBFormat(startDate),
                    enddate: endRangeDateRef.current
                        ? commonService.getDateInDBFormat(endRangeDateRef.current)
                        : commonService.getDateInDBFormat(endDate),
                },
            },
            false,
        );

        let response = apiResponse(false, noteByDataListResponse);

        if (response?.isValidate) {
            setNoteDetail(response?.data?.data);
        }

        if (!response?.isValidate) {
            setNoteDetail(null);
        }
    };

    const callBothApi = () => {
        setChartLoading(true);
        getORGDetail();
        getEventList();
        getPickupFromData();
        getSevenPickupFromData();
        getThreePickupFromData();
        rateShopListAsOfDate();
        past_rateShopListAsOfDate();
        getForecastDetail();
        getBarBasedDetail();
        getNoteByDataList();
        getFLAG_MECHANISM();
        getsetSTLY_LY_COMSET_Rates();
    };

    useEffect(() => {
        if (api === 0) {
            let datesArr = commonService.getDateBetweenTwoDates(
                new Date(startDate),
                new Date(endDate),
            );
            startDateArrayRef.current = datesArr;
            setOrgData(dummyData);
        } else {
            if (para?.asOfDate) {
                // getORGDetail();
                let datesArr = commonService.getDateBetweenTwoDates(
                    commonService.convertDateInTimezone(
                        startRangeDateRef.current ? startRangeDateRef.current : startDate,
                    ),
                    commonService.convertDateInTimezone(
                        endRangeDateRef.current ? endRangeDateRef.current : endDate,
                    ),
                );
                startDateArrayRef.current = datesArr;
                // setMaxDateForPickupFrom(new Date(para?.asOfDate));
                setMaxDateForPickupFrom(new Date(para?.defaultAsOfDate));
                callBothApi();
            }
        }
        if (!selectAsOfDate) {
            setSelectAsOfDate(para?.asOfDate);
        }
    }, [para?.asOfDate, selectAsOfDate, selectedForecast]);

    useEffect(() => {
        setSelectAsOfDate(asOfDateFromRTK);
    }, [asOfDateFromRTK]);

    useEffect(() => {
        if (selectPickupDate) {
            getPickupFromData();
        }
    }, [selectPickupDate]);
    useEffect(() => {
        if (selectSevenPickupDate) {
            getSevenPickupFromData();
        }
    }, [selectSevenPickupDate]);

    useEffect(() => {
        if (selectThreePickupDate) {
            getThreePickupFromData();
        }
    }, [selectThreePickupDate]);

    // Turn off chart loading when main data is available
    useEffect(() => {
        if (orgData !== null && pickupFromData !== null) {
            setChartLoading(false);
        }
    }, [orgData, pickupFromData]);

    const [tblids, settblids] = useState({
        OrgStrategyTable: commonService.GenerateGUID(),
    });
    //commonService.setBackColorPerByTDValue(
    //    "#638EC6",
    //    "Red",
    //    `#${tblids.OrgStrategyTable} .perbackground-otb`
    //);
    //commonService.setBackColorPerByTDValue(
    //    "Green",
    //    "Red",
    //    `#${tblids.OrgStrategyTable} .perbackground-adr`
    //);

    commonService.setBackColorPerByTDValueInPercentage(
        "Green",
        "Red",
        `#${tblids.OrgStrategyTable} .TotalOCCPercentage`,
    );

    commonService.setBackColorPerByTDValueInPercentage(
        "#FFDEA1",
        "Red",
        `#${tblids.OrgStrategyTable} .perbackground-GroupOTB`,
    );

    commonService.setBackColorPerByTDValue(
        "#638EC6",
        "Red",
        `#${tblids.OrgStrategyTable} .perbackground-room`,
    );

    const [ONTHEBOOKS, setONTHEBOOKS] = useState({
        IsDisplay: false,
        // Property: { top: 0, left: 0 },
        Target: null,
        Position: "top",
    });

    const [requestFor, setRequestFor] = useState("");

    const orgStrategyTableRef = useRef(null);
    const [pricingForcastModal, setPricingForcastModal] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });
    const [groupModal, setGroupModal] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });
    useEffect(() => {
        if (orgStrategyTableRef.current) {
            orgStrategyTableRef.current.addEventListener(
                "click",
                handleOrgStrategyTableClick,
            );
        }

        return () => {
            if (orgStrategyTableRef.current) {
                orgStrategyTableRef.current.removeEventListener(
                    "click",
                    handleOrgStrategyTableClick,
                );
            }
        };
    }, []);

    const handleOrgStrategyTableClick = (event) => { };

    const handleFilterBtnClick = (event) => {
        // let screenY = event.screenY;
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        // let Left = event.nativeEvent.layerX + 30;
        if (Top + 400 > window.innerHeight) {
            // Top = Top - 400;
            Position = "top";
        }
        setONTHEBOOKS({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };
    const closeSingleDate = () => {
        selectedTdIndexRef.current = -1;
        // setONTHEBOOKS({ IsDisplay: false, Property: { top: 0, left: 0 } });
        setRequestFor("");
        setONTHEBOOKS({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };

    const handleGroupBtnClick = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setGroupModal({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };

    const closeGroupDate = () => {
        selectedTdIndexRef.current = -1;
        setGroupModal({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };

    const handlePricingForecastBtnClick = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setPricingForcastModal({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };

    const closePricingForecastDate = () => {
        selectedTdIndexRef.current = -1;
        setPricingForcastModal({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };

    const handleExport = async (type) => {
        let tableId = document.querySelector(".dailySummaryTbl");

        if (tableId.querySelector(".loding-animation")) {
            errorToastMessage("Wait for the data loading.");
            return;
        }

        let groupingJson = {
            data: [],
            filename: `${para?.propertyCode}-DailySummary-${moment(new Date()).format(
                "MMDDYYYY",
            )}`,
        };
        let groupingTable = [
            {
                widgetname: "ORG",
                rowdata: [],
            },
        ];
        let totalJson = [
            {
                widgetname: "BlankCommon",
                rowdata: [],
            },
        ];

        groupingTable[0].rowdata.push({
            data: [para?.rowTitle ? para?.rowTitle : ""],
        });
        groupingTable[0].rowdata.push({
            data: [],
        });

        const getTable = document.querySelector(".dailySummaryTbl");

        const findTblHeader = getTable?.querySelectorAll("thead tr");
        const findTblTbody = getTable?.querySelectorAll("tbody tr");

        findTblHeader.forEach((tblHeaderItem, tblHeaderIndex) => {
            let allTh = tblHeaderItem.querySelectorAll("th");
            let allThValue = [];
            allTh.forEach((thItem) => {
                let thSpan = thItem?.querySelector("div>span");
                let thText = thItem?.innerText;
                allThValue.push(
                    thSpan
                        ? thSpan.innerText.toUpperCase() === "EMA"
                            ? "SYSTEM"
                            : thSpan.innerText
                        : thText,
                );
            });

            groupingTable[0].rowdata.push({ data: allThValue });
            if (tblHeaderIndex === 0) {
                groupingTable[0].rowdata.push({ data: [] });
            }
        });

        findTblTbody.forEach((tblBodyItem, tblBodyIndex) => {
            let allTd = tblBodyItem.querySelectorAll("td");
            let allTdValue = [],
                tdTotalValue = [];

            allTd.forEach((tdItem, tdIndex) => {
                let tdText = tdItem?.innerText;
                if (tdIndex === 5 || tdIndex === 16 || tdIndex === 17) {
                    if (findTblTbody?.length - 1 !== tblBodyIndex) {
                        tdText = tdText?.replace("$", "");
                    }
                }
                if (allTd[0].innerText === "Total") {
                    tdTotalValue.push(tdText ? tdText : "");
                } else {
                    allTdValue.push(tdText ? tdText : "");
                }
            });
            if (allTdValue?.length > 0) {
                groupingTable[0].rowdata.push({ data: allTdValue });
            }
            if (tdTotalValue?.length > 0) {
                totalJson[0].rowdata.push({ data: tdTotalValue });
            }
        });
        if (groupingTable?.[0].rowdata?.length > 0) {
            groupingJson.data = [...groupingJson.data, ...groupingTable];
        }
        if (totalJson?.[0].rowdata?.length > 0) {
            groupingJson.data = [...groupingJson.data, ...totalJson];
        }
        groupingJson = {
            ...groupingJson,
            snapshotid: snapshotId ? parseInt(snapshotId) : 0,
            sendtoemails: userDetail?.email ? userDetail?.email : "",
            actiontype: type,
            asofdata: para?.asOfDate
                ? commonService.getDateInDBFormat(para?.asOfDate)
                : "",
        };
        await commonService.widgetWiseExportExcel(groupingJson);
    };

    FixColumn(tblids.OrgStrategyTable, [1]);

    const renderTooltip = (message, item) => (
        <Popover id="popover-id" className="tooltip-flag">
            <div className="m-2">{message}</div>
            <div className="d-flex justify-content-center mb-2">
                <Button id={commonService.generateGlobalClickTrackerID("GroupWash", "ask-rm-copilot", item)}
                    onClick={() => {
                        setFlagModal(true);
                        setFlagModalData({
                            asofdate: para?.asOfDate,
                            dates: item,
                            propertycode: para?.propertyCode,
                        });
                    }}
                >
                    Ask RM Copilot
                </Button>
            </div>
        </Popover>
    );

    const safeDivide = (a, b) => (b ? a / b : 0);

    const getDifferenceInfo = (currentValue, compareValue) => {
        const difference = (currentValue ?? 0) - (compareValue ?? 0);

        return {
            difference,
            className:
                difference < 0 ? "text-danger" : difference > 0 ? "text-success" : "",
        };
    };

    const handleUpdateInputData = async (inputRequest) => {
        try {
            if (
                !inputRequest ||
                !inputRequest.propertycode ||
                !inputRequest.staydate
            ) {
                errorToastMessage(
                    "Invalid request data. Please ensure all required fields are filled.",
                );
                setSaveLoading({ rowId: null, loading: false });
                return;
            }

            let apiResponseData = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.SnapShot +
                        API_URL.GROUP_WASH.GROUP_WASH_ANALYSIS_SAVE,
                    body: [inputRequest],
                },
                false,
            );

            let response = apiResponse(false, apiResponseData);

            if (response?.isValidate && response?.data?.message) {
                successToastMessage("Record saved successfully.");
            } else if (!response?.isValidate) {
                errorToastMessage(
                    response?.data?.message || "Failed to save data. Please try again.",
                );
            }
            setSaveLoading({ rowId: null, loading: false });
        } catch (error) {
            
            errorToastMessage(
                error?.message || "An error occurred while saving. Please try again.",
            );
            setSaveLoading({ rowId: null, loading: false });
        }
    };
    const totals = useMemo(() => {
        let groupBlock = 0;
        let groupConfirm = 0;
        let groupWash = 0;
        let blockChange = 0;
        let confirmChange = 0;
        let washRatio = 0;
        let pickupRatio = 0;

        if (orgData && Array.isArray(orgData) && startDateArrayRef.current) {
            startDateArrayRef.current.forEach((item) => {
                const singleOTBData = orgData.find(
                    (x) =>
                        moment(x.date).format("YYYY-MM-DD") ===
                        moment(item).format("YYYY-MM-DD")
                );
                if (singleOTBData) {
                    groupBlock += Number(singleOTBData.group_block || 0);
                    groupConfirm += Number(singleOTBData.group_otb || 0);
                }
            });
        }

        const wash = groupBlock - groupConfirm;
        groupWash = wash > 0 ? wash : 0;

        pickupRatio = groupBlock > 0 ? ((groupConfirm / groupBlock) * 100).toFixed(0) : 0;
        washRatio = groupBlock > 0 ? ((groupWash / groupBlock) * 100).toFixed(0) : 0;

        // confirmChange = sevenPickupFromDataTotal?.pick_rms || 0;
        // blockChange = sevenPickupFromDataTotal?.pickup_block || 0;

        confirmChange = pickupFromDataTotal?.pick_rms || 0;
        blockChange = pickupFromDataTotal?.pickup_block || 0;

        return {
            groupBlock,
            groupConfirm,
            groupWash,
            pickupRatio,
            washRatio,
            blockChange,
            confirmChange,
        };
        // }, [orgData, sevenPickupFromDataTotal]);
    }, [orgData, pickupFromDataTotal]);

    return (
        <div className="widget-container" style={{ position: "relative" }}>
            <div className="d-flex justify-content-between align-items-baseline">
                <header className="groupwash-header mb-1">
                    <h6>Group Wash Analysis</h6>
                </header>
                <div className="groupiq-legend">
                    <span className="groupiq-legend-item"><span className="groupiq-legend-color groupiq-legend-clear"></span> CLEAR ≤30%</span>
                    <span className="groupiq-legend-item"><span className="groupiq-legend-color groupiq-legend-watch"></span> WATCH 30-60%</span>
                    <span className="groupiq-legend-item"><span className="groupiq-legend-color groupiq-legend-warn"></span> WARN 60-75%</span>
                    <span className="groupiq-legend-item"><span className="groupiq-legend-color groupiq-legend-critical"></span> CRITICAL >75%</span>
                </div>
            </div>

            <div className="groupiq-summary-cards">
                {loading || chartLoading ? (
                    <Skeleton skeletonType="GroupWashCards" />
                ) : (
                    <>
                        <div className="groupiq-summary-card groupiq-card-block">
                            <div className="groupiq-summary-card-label">GROUP BLOCK</div>
                            <div className="groupiq-summary-card-value">
                                {totals.groupBlock}{" "}
                                <span className="groupiq-summary-card-unit">rms</span>
                            </div>
                            <div className="groupiq-summary-card-change">
                                <span className="groupiq-summary-card-change-badge groupiq-badge-green">
                                    ↑
                                </span>
                                <span className="groupiq-summary-card-change-text">
                                    Δ{" "}
                                    {totals?.blockChange > 0
                                        ? `+${totals?.blockChange}`
                                        : totals?.blockChange}{" "}
                                    last 1d
                                    {/* last 7d */}
                                </span>
                            </div>
                        </div>

                        <div className="groupiq-summary-card groupiq-card-confirmed">
                            <div className="groupiq-summary-card-label">GROUP CONFIRMED</div>
                            <div className="groupiq-summary-card-value">
                                {totals.groupConfirm}{" "}
                                <span className="groupiq-summary-card-unit">rms</span>
                            </div>
                            <div className="groupiq-summary-card-change">
                                <span className="groupiq-summary-card-change-badge groupiq-badge-green">
                                    ↑
                                </span>
                                <span className="groupiq-summary-card-change-text">
                                    Δ{" "}
                                    {totals?.confirmChange > 0
                                        ? `+${totals?.confirmChange}`
                                        : totals?.confirmChange}{" "}
                                    last 1d
                                    {/* last 7d */}
                                </span>
                            </div>
                        </div>

                        <div className="groupiq-summary-card groupiq-card-wash">
                            <div className="groupiq-summary-card-label">GROUP WASH</div>
                            <div className="groupiq-summary-card-value">
                                {totals.groupWash}{" "}
                                <span className="groupiq-summary-card-unit">rms</span>
                            </div>
                            <div className="groupiq-summary-card-change">
                                <span className="groupiq-summary-card-change-badge groupiq-badge-red">
                                    ↑
                                </span>
                                <span className="groupiq-summary-card-change-text">
                                    {totals?.washRatio}% of group block ·{" "}
                                    {totals?.washRatio > 75
                                        ? "Critical"
                                        : totals?.washRatio > 60
                                            ? "Warn"
                                            : totals?.washRatio > 30
                                                ? "Watch"
                                                : "Clear"}
                                </span>
                            </div>
                        </div>

                        <div className="groupiq-summary-card groupiq-card-ratio">
                            <div className="groupiq-summary-card-label">GROUP PICKUP RATIO</div>
                            <div className="groupiq-summary-card-value">
                                {totals.pickupRatio}
                                <span className="groupiq-percent-large">%</span>
                            </div>
                            <div className="groupiq-summary-card-change">
                                <span className="groupiq-summary-card-change-badge groupiq-badge-green">
                                    ↑
                                </span>
                                <span className="groupiq-summary-card-change-text">
                                    {totals.groupConfirm}/{totals.groupBlock} converted
                                </span>
                            </div>
                        </div>
                    </>
                )}
            </div>
            <div className="d-flex justify-content-center p-2">
                {/* {(loading || chartLoading) && (
      <>
      <span
          className="spinner-border spinner-border-sm me-2 text-primary"
          role="status"
          aria-hidden="true"
        ></span>   
        <span>
          Fetching data, please wait...
          </span>
      </>
    )} */}
            </div>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("GroupWash", "infoIcon", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.GroupWash,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button" title="Send Mail">
                        <img id={commonService.generateGlobalClickTrackerID("GroupWash", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                commonService.fnSendWidgetMail(
                                    tblids.OrgStrategyTable,
                                    "Groupwash",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId,
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("GroupWash", "downloadIcon", propertyCode)}
                            src={downloadIcon}
                            alt="download"
                            import={tblids.OrgStrategyTable}
                            onClick={() => {
                                commonService.fnExportInCSV(
                                    tblids.OrgStrategyTable,
                                    // "Strategy"
                                    `${para?.propertyCode}-Groupwash-${moment(new Date()).format(
                                        "MMDDYYYY",
                                    )}`,
                                );
                            }}
                        />
                    </Button>
                </div>
            )}
            <div className="ViewPropertySetupTable mainTableClass">
                <div className="stripped__table">
                    <div className="table-responsive tblDynamicPickupSticky">
                        <Table
                            id={tblids.OrgStrategyTable}
                            className="table-with-spacing positionStaticTable dailySummaryTbl"
                            ref={orgStrategyTableRef}
                        >
                            <thead className="tbl-header-sticky">
                                <tr className="diff-bg-tr table-main-header-tr">
                                    <th className="width150" colSpan={3}>
                                        {/* <div className="d-flex flex-column align-items-start">
                                            <span>AsOfDate</span>
                                            <DatePicker
                                                portalId="datepicker-root"
                                                className=" "
                                                id="asOfDate"
                                                maxDate={new Date(para?.defaultAsOfDate)}
                                                selected={
                                                    selectAsOfDate
                                                        ? commonService.convertDateInTimezone(
                                                            selectAsOfDate
                                                        )
                                                        : ""
                                                }
                                                onChange={(date) => {
                                                    let month =
                                                        date.getMonth() + 1 > 9
                                                            ? date.getMonth() + 1
                                                            : `0${date.getMonth() + 1}`;
                                                    let dateFormat =
                                                        date?.getDate() > 9
                                                            ? date.getDate()
                                                            : `0${date.getDate()}`;
                                                    let selectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
                                                    setSelectAsOfDate(selectedDate);
                                                }}
                                            />
                                            <span style={{ display: "none" }}>
                                                {selectAsOfDate
                                                    ? commonService.getDateInFormat(
                                                        new Date(selectAsOfDate)
                                                    )
                                                    : ""}
                                            </span>
                                        </div> */}
                                    </th>

                                    <th className="border-right text-center" colSpan={6}>
                                        Group Block
                                    </th>

                                    <th className="border-right width100 text-center" colSpan={4}>
                                        <div className="">
                                            <span>DBA 1 Day Pickup</span>
                                            <DatePicker
                                                portalId="datepicker-root"
                                                className=""
                                                id="pickupDate"
                                                maxDate={new Date(maxDateRef.current)}
                                                selected={
                                                    selectPickupDate
                                                        ? commonService.convertDateInTimezone(
                                                            selectPickupDate,
                                                        )
                                                        : commonService.convertDateInTimezone(
                                                            maxDateRef.current,
                                                        )
                                                }
                                                onChange={(date) => {
                                                    let month =
                                                        date.getMonth() + 1 > 9
                                                            ? date.getMonth() + 1
                                                            : `0${date.getMonth() + 1}`;
                                                    let dateFormat =
                                                        date?.getDate() > 9
                                                            ? date.getDate()
                                                            : `0${date.getDate()}`;
                                                    let selectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
                                                    singleDatePickupDateRef.current = selectedDate;
                                                    setSelectPickupDate(selectedDate);
                                                }}
                                            />
                                            <span style={{ display: "none" }}>
                                                {selectPickupDate
                                                    ? commonService.getDateInFormat(
                                                        new Date(selectPickupDate),
                                                    )
                                                    : commonService.getDateInFormat(
                                                        new Date(maxDateRef.current),
                                                    )}
                                            </span>
                                        </div>
                                    </th>

                                    <th className="border-right width100 text-center" colSpan={4}>
                                        <div className="">
                                            <span>DBA 3 Day Pickup</span>
                                            <DatePicker
                                                portalId="datepicker-root"
                                                className=""
                                                id="pickupDate"
                                                maxDate={new Date(threeMaxDateRef.current)}
                                                selected={
                                                    selectThreePickupDate
                                                        ? commonService.convertDateInTimezone(
                                                            selectThreePickupDate,
                                                        )
                                                        : commonService.convertDateInTimezone(
                                                            threeMaxDateRef.current,
                                                        )
                                                }
                                                onChange={(date) => {
                                                    let month =
                                                        date.getMonth() + 1 > 9
                                                            ? date.getMonth() + 1
                                                            : `0${date.getMonth() + 1}`;
                                                    let dateFormat =
                                                        date?.getDate() > 9
                                                            ? date.getDate()
                                                            : `0${date.getDate()}`;
                                                    let selectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
                                                    setSelectThreePickupDate(selectedDate);
                                                }}
                                            />
                                            <span style={{ display: "none" }}>
                                                {selectThreePickupDate
                                                    ? commonService.getDateInFormat(
                                                        new Date(selectThreePickupDate),
                                                    )
                                                    : commonService.getDateInFormat(
                                                        new Date(threeMaxDateRef.current),
                                                    )}
                                            </span>
                                        </div>
                                    </th>

                                    <th className="border-right width100 text-center" colSpan={4}>
                                        <div className="">
                                            <span>DBA 7 Day Pickup</span>
                                            <DatePicker
                                                portalId="datepicker-root"
                                                className=""
                                                id="pickupDate"
                                                maxDate={new Date(sevenMaxDateRef.current)}
                                                selected={
                                                    selectSevenPickupDate
                                                        ? commonService.convertDateInTimezone(
                                                            selectSevenPickupDate,
                                                        )
                                                        : commonService.convertDateInTimezone(
                                                            sevenMaxDateRef.current,
                                                        )
                                                }
                                                onChange={(date) => {
                                                    let month =
                                                        date.getMonth() + 1 > 9
                                                            ? date.getMonth() + 1
                                                            : `0${date.getMonth() + 1}`;
                                                    let dateFormat =
                                                        date?.getDate() > 9
                                                            ? date.getDate()
                                                            : `0${date.getDate()}`;
                                                    let selectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
                                                    setSelectSevenPickupDate(selectedDate);
                                                }}
                                            />
                                            <span style={{ display: "none" }}>
                                                {selectSevenPickupDate
                                                    ? commonService.getDateInFormat(
                                                        new Date(selectSevenPickupDate),
                                                    )
                                                    : commonService.getDateInFormat(
                                                        new Date(sevenMaxDateRef.current),
                                                    )}
                                            </span>
                                        </div>
                                    </th>

                                    <th className="border-right text-center" colSpan={3}>
                                        Transient
                                    </th>

                                    <th className="border-right text-center" colSpan={3}>
                                        Actual / On-Books
                                    </th>

                                    <th className="text-center border-right" colSpan={3}>
                                        Pricing & Forecast
                                    </th>
                                    {rateShopListData && (
                                        <th
                                            colSpan={
                                                rateShopListData?.filter(
                                                    (x) =>
                                                        x.CheckInDate ===
                                                        moment(rateShopListData?.[0]?.CheckInDate).format(
                                                            "YYYY-MM-DD",
                                                        ),
                                                )?.length *
                                                2 +
                                                5
                                            }
                                            className="border-right text-center"
                                        >
                                            RateShop ({propertyChannel} , BAR)
                                        </th>
                                    )}
                                    <th className="border-right"></th>
                                </tr>
                                <tr className="table-main-header-tr">
                                    <th id={commonService.generateGlobalClickTrackerID("GroupWash", "occ-date", propertyCode)}
                                        className="width175 text-center"
                                        onClick={() => {
                                            setOpenDatePicker(true);
                                        }}
                                    >
                                        OCC Date{" "}
                                        <DatePicker id={commonService.generateGlobalClickTrackerID("GroupWash", "occ-date-picker", propertyCode)}
                                            portalId="datepicker-root"
                                            onChange={(event) => handleDateChange(event)}
                                            startDate={startRangeDate}
                                            endDate={endRangeDate}
                                            selectsRange
                                            monthsShown={2}
                                            open={openDatePicker}
                                            shouldCloseOnSelect={false}
                                        >
                                            <div
                                                className="w-100"
                                                style={{ display: "inline-block" }}
                                            >
                                                <CustomRangePicker id={commonService.generateGlobalClickTrackerID("GroupWash", "occ-date-rangepicker", propertyCode)}
                                                    activePreset={activePresetRange}
                                                    setActivePreset={setActivePresetRange}
                                                    setOpenDatePicker={setOpenDatePicker}
                                                    onChange={(start, end, type) => {
                                                        setStartRangeDate(start);
                                                        setEndRangeDate(end);
                                                        handleApplyRange(start, end);
                                                    }}
                                                />
                                                <div className="content-inside-calendar">
                                                    <p>
                                                        {startRangeDate
                                                            ? commonService.getDateInFormat(startRangeDate)
                                                            : ""}
                                                        {startRangeDate && endRangeDate ? " - " : ""}
                                                        {endRangeDate
                                                            ? commonService.getDateInFormat(endRangeDate)
                                                            : ""}
                                                    </p>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <button id={commonService.generateGlobalClickTrackerID("GroupWash", "occ-date-cancel-btn", propertyCode)}
                                                            className="secondary-btn"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setStartRangeDate("");
                                                                setEndRangeDate("");
                                                                startRangeDateRef.current = "";
                                                                endRangeDateRef.current = "";
                                                                setOpenDatePicker(false);
                                                                setActivePresetRange(null);
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>
                                                        <button id={commonService.generateGlobalClickTrackerID("GroupWash", "occ-date-apply-btn", propertyCode)}
                                                            disabled={
                                                                startRangeDate && endRangeDate ? false : true
                                                            }
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                if (
                                                                    startRangeDateRef.current &&
                                                                    endRangeDateRef.current
                                                                ) {
                                                                    let datesArr =
                                                                        commonService.getDateBetweenTwoDates(
                                                                            commonService.convertDateInTimezone(
                                                                                startRangeDateRef.current,
                                                                            ),
                                                                            commonService.convertDateInTimezone(
                                                                                endRangeDateRef.current,
                                                                            ),
                                                                        );
                                                                    startDateArrayRef.current = datesArr;
                                                                    callBothApi();
                                                                }
                                                                setOpenDatePicker(false);
                                                                setActivePresetRange(null);
                                                            }}
                                                            className="primary-btn"
                                                        >
                                                            Apply
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </DatePicker>
                                        {startRangeDate && endRangeDate && (
                                            <span
                                                style={{ display: "none" }}
                                            >{`${commonService.getDateInFormat(
                                                startRangeDate,
                                            )} - ${commonService.getDateInFormat(
                                                endRangeDate,
                                            )}`}</span>
                                        )}
                                    </th>
                                    <th className="text-center">DTA</th>
                                    <th className="text-center">
                                        Actual <br /> inventory
                                    </th>

                                    <th className="text-center border-right">Block</th>
                                    <th className="text-center ">Confirm</th>
                                    {/* <th className="text-center ">
                    Avail <br /> Block{" "}
                  </th> */}
                                    <th className="text-center ">ADR</th>
                                    <th className="text-end ">REV</th>
                                    <th className="width150 text-center">
                                        Sys Wash <br />
                                        <span className="groupwash-header-sublabel">rooms / %</span>
                                    </th>

                                    <th className="width150 text-center">
                                        User Wash %
                                        {/* <br /> <span className="groupwash-header-sublabel">editable %</span> */}
                                    </th>

                                    {/* <th className="width100 border-right">OOO\Rooms Available</th>
                                    <th className="width75 text-center ">Left To sell</th>
                                    <th className="width75 text-center ">AVG LT</th>
                                    <th className="width75 text-center">On The Books</th>
                                    <th>Total OCC%</th>
                                    <th className="text-end">ADR</th> */}

                                    {/* <th className="text-center border-right">Rev</th>
                                    <th className="text-end">RevPAR</th> */}

                                    {/* {/*<th className=" border-right">OTB\Block</th> */}

                                    {/* <th className="width50 text-center border-right">OTB</th>
                                    <th className="width100 text-center">8 Week Rolling Avg</th> */}

                                    {/* <th className="text-end border-right">ADR</th>
                                    <th className="text-center">OTB</th>
                                    <th className="text-end">Rev</th>
                                    <th className="text-center">AVG LT</th> */}

                                    {/* <th className="text-end border-right">ADR</th>
                                    <th className="text-center">OTB</th>
                                    <th className="text-end">Rev</th>
                                    <th className="text-center">AVG LT</th> */}

                                    <th className="border-right text-center">
                                        {/* Rooms  */}
                                        OTB/Block </th>
                                    <th></th>
                                    <th className="text-end">ADR Change</th>
                                    <th className="text-end">Rev</th>

                                    <th className="border-right text-center">
                                        {/* Rooms */}
                                        OTB/Block
                                    </th>
                                    <th></th>
                                    <th className="text-end">ADR Change</th>
                                    <th className="text-end">Rev</th>

                                    <th className="border-right text-center">
                                        {/* Rooms */}
                                        OTB/Block
                                    </th>
                                    <th></th>
                                    <th className="text-end">ADR Change</th>
                                    <th className="text-end">Rev</th>

                                    <th className="border-right text-center">RMS</th>
                                    <th className="text-end">ADR</th>
                                    <th className="text-end">REV</th>

                                    <th className="border-right text-center">RMS</th>
                                    <th className="text-end">ADR</th>
                                    <th className="text-end">REV</th>

                                    <th className="text-center border-right width110">
                                        <div>
                                            <Form.Select id={commonService.generateGlobalClickTrackerID("GroupWash", "forecast-selection", propertyCode)}
                                                value={selectedForecast}
                                                onChange={(e) => {
                                                    setSelectedForecast(e.target.value);
                                                }}
                                            >
                                                <option value="ema">System Forecast</option>
                                                <option value="rms">RMS Forecast</option>
                                                <option value="user">USER Forecast</option>
                                                <option value="nova">RM Copilot Forecast</option>
                                            </Form.Select>
                                            <span style={{ display: "none" }}>
                                                {commonService.ForecastTypeDisplayLable(
                                                    selectedForecast,
                                                )}
                                            </span>
                                        </div>
                                    </th>
                                    <th>R28 Avg</th>
                                    <th className="text-end">Optimal Bar</th>

                                    {rateShopListData &&
                                        rateShopListData?.map((x) => {
                                            if (
                                                x.CheckInDate ===
                                                moment(rateShopListData?.[0]?.CheckInDate).format(
                                                    "YYYY-MM-DD",
                                                ) &&
                                                x.IsSelf === true
                                            ) {
                                                return (
                                                    <th
                                                        className="text-end border-right"
                                                        title={x?.competiterpropertyname}
                                                        colSpan={2}
                                                        data-export={x?.competiterpropertyname}
                                                    >
                                                        {x?.competiterpropertyname?.length > 10
                                                            ? `${x?.competiterpropertyname?.slice(0, 10)}...`
                                                            : x?.competiterpropertyname}
                                                    </th>
                                                );
                                            }
                                        })}
                                    {rateShopListData && (
                                        <>
                                            <th className="text-end border-right" colSpan={2}>
                                                Comp Set Avg
                                            </th>
                                            <th className="text-end">STLY Avg</th>
                                            <th className="text-end border-end">LY Avg</th>
                                        </>
                                    )}
                                    {rateShopListData &&
                                        rateShopListData?.map((x) => {
                                            if (
                                                x.CheckInDate ===
                                                moment(rateShopListData?.[0]?.CheckInDate).format(
                                                    "YYYY-MM-DD",
                                                ) &&
                                                x.IsSelf === false
                                            ) {
                                                return (
                                                    <th
                                                        className="text-end"
                                                        title={x?.competiterpropertyname}
                                                        colSpan={2}
                                                        data-export={x?.competiterpropertyname}
                                                    >
                                                        {x?.competiterpropertyname?.length > 10
                                                            ? `${x?.competiterpropertyname?.slice(0, 10)}...`
                                                            : x?.competiterpropertyname}
                                                    </th>
                                                );
                                            }
                                        })}
                                    <th className="border-right text-center">Notes</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(!startDateArrayRef.current || startDateArrayRef.current.length === 0) ? (
                                    <tr style={{ height: "80px", position: "relative" }}>
                                        <Loader />
                                    </tr>
                                ) : (
                                    startDateArrayRef.current?.map((item, index) => {
                                        dayName = false;
                                        if (
                                            moment(new Date(item), "l").format("ddd") === "Fri" ||
                                            moment(new Date(item), "l").format("ddd") === "Sat"
                                        ) {
                                            dayName = true;
                                        }

                                        let singlePickupData = pickupFromData?.filter(
                                            (x) =>
                                                moment(x.dates).format("YYYY-MM-DD") ===
                                                moment(item).format("YYYY-MM-DD"),
                                        );

                                        let threePickupData = threePickupFromData?.filter(
                                            (x) =>
                                                moment(x.dates).format("YYYY-MM-DD") ===
                                                moment(item).format("YYYY-MM-DD"),
                                        );

                                        let sevenPickupData = sevenPickupFromData?.filter(
                                            (x) =>
                                                moment(x.dates).format("YYYY-MM-DD") ===
                                                moment(item).format("YYYY-MM-DD"),
                                        );

                                        let singleOTBData = orgData?.filter(
                                            (x) =>
                                                moment(x.date).format("YYYY-MM-DD") ===
                                                moment(item).format("YYYY-MM-DD"),
                                        );


                                        Total_ActualInventory =
                                            Total_ActualInventory +
                                            (singleOTBData?.[0]?.inventory
                                                ? singleOTBData?.[0]?.inventory
                                                : 0);
                                        Total_GRP_Block =
                                            Total_GRP_Block +
                                            (singleOTBData?.[0]?.group_block
                                                ? singleOTBData?.[0]?.group_block
                                                : 0);
                                        Total_GRP_Confirm =
                                            Total_GRP_Confirm +
                                            (singleOTBData?.[0]?.group_otb
                                                ? singleOTBData?.[0]?.group_otb
                                                : 0);
                                        Total_GRP_Avail_Block =
                                            Total_GRP_Avail_Block +
                                            (singleOTBData?.[0]?.available_block
                                                ? singleOTBData?.[0]?.available_block
                                                : 0);
                                        Total_GRP_Rev =
                                            Total_GRP_Rev +
                                            (singleOTBData?.[0]?.group_revenue
                                                ? singleOTBData?.[0]?.group_revenue
                                                : 0);
                                        Total_GRP_SysWash =
                                            Total_GRP_SysWash +
                                            (singleOTBData?.[0]?.system_wash
                                                ? parseFloat(singleOTBData?.[0]?.system_wash)
                                                : 0);
                                        const groupBlockForWash = singleOTBData?.[0]?.group_block ?? 0;
                                        const userWashPct = parseFloat(singleOTBData?.[0]?.user_wash_pct) || 0;
                                        const userWashRooms = Math.round((userWashPct * groupBlockForWash) / 100);
                                        Total_GRP_UserWash = Total_GRP_UserWash + userWashRooms;
                                        Total_TRA_Rms =
                                            Total_TRA_Rms +
                                            (singleOTBData?.[0]?.transient_otb
                                                ? singleOTBData?.[0]?.transient_otb
                                                : 0);
                                        Total_TRA_Rev =
                                            Total_TRA_Rev +
                                            (singleOTBData?.[0]?.transient_revenue
                                                ? singleOTBData?.[0]?.transient_revenue
                                                : 0);
                                        Total_AOB_Rms =
                                            Total_AOB_Rms +
                                            (singleOTBData?.[0]?.total_otb
                                                ? singleOTBData?.[0]?.total_otb
                                                : 0);
                                        Total_AOB_Rev =
                                            Total_AOB_Rev +
                                            (singleOTBData?.[0]?.total_revenue
                                                ? singleOTBData?.[0]?.total_revenue
                                                : 0);

                                        ooo =
                                            ooo +
                                            (singleOTBData?.[0]?.OOO ? singleOTBData?.[0]?.OOO : 0);
                                        RmsAvailable =
                                            RmsAvailable +
                                            (singleOTBData?.[0]?.RoomAvailable
                                                ? singleOTBData?.[0]?.RoomAvailable
                                                : 0);
                                        leftToSell =
                                            leftToSell +
                                            (singleOTBData?.[0]?.LeftToSell
                                                ? singleOTBData?.[0]?.LeftToSell
                                                : 0);
                                        avgleadtime =
                                            avgleadtime +
                                            (singleOTBData?.[0]?.avgleadtime
                                                ? singleOTBData?.[0]?.avgleadtime
                                                : 0);
                                        otb =
                                            otb +
                                            (singleOTBData?.[0]?.OnTheBook
                                                ? singleOTBData?.[0]?.OnTheBook
                                                : 0);
                                        occPercentage =
                                            occPercentage +
                                            (singleOTBData?.[0]?.TotalOCCPercentage
                                                ? singleOTBData?.[0]?.TotalOCCPercentage
                                                : 0);
                                        adr =
                                            adr +
                                            (singleOTBData?.[0]?.ADR ? singleOTBData?.[0]?.ADR : 0);
                                        rev =
                                            rev +
                                            (singleOTBData?.[0]?.REV ? singleOTBData?.[0]?.REV : 0);
                                        revPar =
                                            revPar +
                                            (singleOTBData?.[0]?.RevPAR
                                                ? singleOTBData?.[0]?.RevPAR
                                                : 0);
                                        groupOTB =
                                            groupOTB +
                                            (singleOTBData?.[0]?.OTB ? singleOTBData?.[0]?.OTB : 0);
                                        groupBlock =
                                            groupBlock +
                                            (singleOTBData?.[0]?.Block
                                                ? singleOTBData?.[0]?.Block
                                                : 0);
                                        pickupRooms =
                                            pickupRooms +
                                            (singlePickupData?.[0]?.rms
                                                ? singlePickupData?.[0]?.rms
                                                : 0);
                                        pickupAdr =
                                            pickupAdr +
                                            (singlePickupData?.[0]?.adr
                                                ? singlePickupData?.[0]?.adr
                                                : 0);
                                        // --- Prev ---
                                        // pickupRev =
                                        //     pickupRev +
                                        //     (singlePickupData?.[0]?.RMS
                                        //         ? singlePickupData?.[0]?.RMS
                                        //         : 0) *
                                        //     (singlePickupData?.[0]?.ADR
                                        //         ? singlePickupData?.[0]?.ADR
                                        //         : 0);

                                        // --- Current ---
                                        pickupRev =
                                            pickupRev +
                                            (singlePickupData?.[0]?.rev
                                                ? singlePickupData?.[0]?.rev
                                                : 0);

                                        if (singlePickupData?.[0]?.adr) {
                                            if (singlePickupData?.[0]?.adr !== 0) {
                                                pickupAdrCount = pickupAdrCount + 1;
                                            }
                                        }

                                        sevenPickupRooms =
                                            sevenPickupRooms +
                                            (sevenPickupData?.[0]?.rms
                                                ? sevenPickupData?.[0]?.rms
                                                : 0);
                                        sevenPickupAdr =
                                            sevenPickupAdr +
                                            (sevenPickupData?.[0]?.adr
                                                ? sevenPickupData?.[0]?.adr
                                                : 0);
                                        if (sevenPickupData?.[0]?.adr) {
                                            if (sevenPickupData?.[0]?.adr !== 0) {
                                                sevenPickupAdrCount = sevenPickupAdrCount + 1;
                                            }
                                        }

                                        // --- Prev ---
                                        // sevenPickupRev =
                                        //     sevenPickupRev +
                                        //     (sevenPickupData?.[0]?.RMS
                                        //         ? sevenPickupData?.[0]?.RMS
                                        //         : 0) *
                                        //     (sevenPickupData?.[0]?.adr
                                        //         ? sevenPickupData?.[0]?.adr
                                        //         : 0);

                                        // --- Current ---
                                        sevenPickupRev =
                                            sevenPickupRev +
                                            (sevenPickupData?.[0]?.REV
                                                ? sevenPickupData?.[0]?.REV
                                                : 0);

                                        /*Three Day*/

                                        threePickupRooms =
                                            threePickupRooms +
                                            (threePickupData?.[0]?.rms
                                                ? threePickupData?.[0]?.rms
                                                : 0);
                                        threePickupAdr =
                                            threePickupAdr +
                                            (threePickupData?.[0]?.adr
                                                ? threePickupData?.[0]?.adr
                                                : 0);
                                        if (threePickupData?.[0]?.adr) {
                                            if (threePickupData?.[0]?.adr !== 0) {
                                                threePickupAdrCount = threePickupAdrCount + 1;
                                            }
                                        }

                                        // --- Prev ---
                                        // threePickupRev =
                                        //     threePickupRev +
                                        //     (threePickupData?.[0]?.rms
                                        //         ? threePickupData?.[0]?.rms
                                        //         : 0) *
                                        //     (threePickupData?.[0]?.adr
                                        //         ? threePickupData?.[0]?.adr
                                        //         : 0);

                                        // --- Current ---
                                        threePickupRev =
                                            threePickupRev +
                                            (threePickupData?.[0]?.rev
                                                ? threePickupData?.[0]?.rev
                                                : 0);

                                        let singleForecastData = forecastData?.filter(
                                            (x) =>
                                                moment(x.Dates).format("YYYY-MM-DD") ===
                                                moment(item).format("YYYY-MM-DD"),
                                        );

                                        let singleBarBasedData = barBasedData?.filter(
                                            (x) =>
                                                moment(x.StayDate).format("YYYY-MM-DD") ===
                                                moment(item).format("YYYY-MM-DD"),
                                        );

                                        barBasedOTB =
                                            barBasedOTB +
                                            (singleBarBasedData?.[0]?.OTB
                                                ? parseInt(singleBarBasedData?.[0]?.OTB)
                                                : 0);

                                        baeBasedRollingAvg =
                                            baeBasedRollingAvg +
                                            (singleBarBasedData?.[0]?.["8 Week Rolling AVG"]
                                                ? parseInt(
                                                    singleBarBasedData?.[0]?.["8 Week Rolling AVG"],
                                                )
                                                : 0);

                                        let isSelfData = rateShopListData?.filter((x) => {
                                            if (
                                                x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                x.IsSelf === true
                                            ) {
                                                return x;
                                            }
                                        });

                                        let SelfDataRateDiff = 0;

                                        let past_isSelfData = past_rateShopListData?.filter((x) => {
                                            if (
                                                x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                x.IsSelf === true
                                            ) {
                                                return x;
                                            }
                                        });

                                        if (
                                            past_isSelfData &&
                                            past_isSelfData.length > 0 &&
                                            isSelfData &&
                                            isSelfData.length > 0
                                        ) {
                                            let PDRate = past_isSelfData[0]?.Rate
                                                ? past_isSelfData[0]?.Rate
                                                : 0;
                                            let Rate = isSelfData[0]?.Rate ? isSelfData[0]?.Rate : 0;
                                            SelfDataRateDiff = parseInt(PDRate) - parseInt(Rate);
                                        }

                                        let rateShoptotal = 0;
                                        rateShopListData?.map((x) => {
                                            if (
                                                x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                x.IsSelf === false
                                            ) {
                                                rateShoptotal = rateShoptotal + parseFloat(x?.Rate);
                                            }
                                        });

                                        let findCompetitorData = rateShopListData?.filter(
                                            (x) =>
                                                x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                x.IsSelf === false,
                                        );

                                        let past_findCompetitorData = past_rateShopListData?.filter(
                                            (x) =>
                                                x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                x.IsSelf === false,
                                        );

                                        let findDataForAvgCount = rateShopListData?.filter(
                                            (x) =>
                                                x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                x.IsSelf === false &&
                                                parseFloat(x.Rate) > 0,
                                        );

                                        let avgCompetitor =
                                            rateShoptotal > 0 && findDataForAvgCount?.length > 0
                                                ? Math.round(
                                                    rateShoptotal / findDataForAvgCount?.length,
                                                )
                                                : 0;

                                        let past_rateShoptotal = 0;

                                        past_rateShopListData?.map((x) => {
                                            if (
                                                x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                x.IsSelf === false
                                            ) {
                                                past_rateShoptotal =
                                                    past_rateShoptotal + parseFloat(x?.Rate);
                                            }
                                        });

                                        let past_findDataForAvgCount =
                                            past_rateShopListData?.filter(
                                                (x) =>
                                                    x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                    x.IsSelf === false &&
                                                    parseFloat(x.Rate) > 0,
                                            );

                                        let past_avgCompetitor =
                                            past_rateShoptotal > 0 &&
                                                past_findDataForAvgCount?.length > 0
                                                ? Math.round(
                                                    past_rateShoptotal /
                                                    past_findDataForAvgCount?.length,
                                                )
                                                : 0;

                                        let avgCompetitorRateDiff = 0;

                                        avgCompetitorRateDiff =
                                            parseInt(past_avgCompetitor) - parseInt(avgCompetitor);

                                        let dataExistsOrNot = rateShopListData?.filter((x) => {
                                            if (
                                                x?.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                x?.IsSelf === false
                                            ) {
                                                return x;
                                            }
                                        });

                                        let checkEvent = eventListRef.current?.filter((x) => {
                                            let checkingDate = moment(item);
                                            let startingDate = moment(x?.startDate);
                                            let endingDate = moment(x?.endDate);
                                            if (
                                                checkingDate.isSameOrAfter(startingDate) &&
                                                checkingDate.isSameOrBefore(endingDate)
                                            ) {
                                                return x;
                                            }
                                        });

                                        let foreCastSpiderTextColor = "";
                                        let forecastSpiderBorder = "";
                                        if (
                                            singleForecastData?.[0]?.RMS <
                                            singleForecastData?.[0]?.R28AVG
                                        ) {
                                            foreCastSpiderTextColor = "redText";
                                            let R28AvgPercentage =
                                                (singleForecastData?.[0]?.R28AVG * 10) / 100;
                                            let finalValue =
                                                singleForecastData?.[0]?.R28AVG - R28AvgPercentage;
                                            if (singleForecastData?.[0]?.RMS < finalValue) {
                                                forecastSpiderBorder = "redBorderTd";
                                            }
                                        } else {
                                            let R28AvgPercentage =
                                                (singleForecastData?.[0]?.R28AVG * 10) / 100;
                                            let finalValue =
                                                singleForecastData?.[0]?.R28AVG + R28AvgPercentage;
                                            if (singleForecastData?.[0]?.RMS > finalValue) {
                                                forecastSpiderBorder = "blackBorderTd";
                                            }
                                        }

                                        let checkNoteExists = noteDetail?.notedata?.filter(
                                            (x) =>
                                                moment(x?.datadate).format("YYYY-MM-DD") ===
                                                moment(item).format("YYYY-MM-DD"),
                                        );

                                        let flagType = null;
                                        let flagvalue = "0";
                                        if (FLAG_MECHANISM && FLAG_MECHANISM.length > 0) {
                                            let flagdata = FLAG_MECHANISM.filter(
                                                (x) =>
                                                    moment(x.dates).format("YYYY-MM-DD") ===
                                                    moment(item).format("YYYY-MM-DD"),
                                            );
                                            if (flagdata && flagdata.length > 0) {
                                                if (flagdata[0]?.demandtag) {
                                                    if (
                                                        flagdata[0]?.demandtag
                                                            .toUpperCase()
                                                            .replaceAll(" ", "") === "HIGH"
                                                    ) {
                                                        flagType = (
                                                            <OverlayTrigger
                                                                placement="right"
                                                                delay={{ show: 250, hide: 2000 }}
                                                                overlay={renderTooltip(
                                                                    flagdata[0]?.message,
                                                                    item,
                                                                )}
                                                            >
                                                                <img
                                                                    src={DemandScore_High}
                                                                    alt=""
                                                                    style={{ height: "11px", width: "11px" }}
                                                                />
                                                            </OverlayTrigger>
                                                        );
                                                    } else if (
                                                        flagdata[0]?.demandtag
                                                            .toUpperCase()
                                                            .replaceAll(" ", "") === "LOW"
                                                    ) {
                                                        flagType = (
                                                            <OverlayTrigger
                                                                placement="right"
                                                                delay={{ show: 250, hide: 2000 }}
                                                                message={flagdata[0]?.message}
                                                                overlay={renderTooltip(
                                                                    flagdata[0]?.message,
                                                                    item,
                                                                )}
                                                            >
                                                                <img
                                                                    src={DemandScore_Low}
                                                                    alt=""
                                                                    style={{ height: "11px", width: "11px" }}
                                                                />
                                                            </OverlayTrigger>
                                                        );
                                                    } else if (
                                                        flagdata[0]?.demandtag
                                                            .toUpperCase()
                                                            .replaceAll(" ", "") === "MODERATE"
                                                    ) {
                                                        flagType = (
                                                            <OverlayTrigger
                                                                placement="right"
                                                                delay={{ show: 250, hide: 2000 }}
                                                                message={flagdata[0]?.message}
                                                                overlay={renderTooltip(
                                                                    flagdata[0]?.message,
                                                                    item,
                                                                )}
                                                            >
                                                                <img
                                                                    src={DemandScore_Moderate}
                                                                    alt=""
                                                                    style={{ height: "11px", width: "11px" }}
                                                                />
                                                            </OverlayTrigger>
                                                        );
                                                    } else if (
                                                        flagdata[0]?.demandtag
                                                            .toUpperCase()
                                                            .replaceAll(" ", "") === "VERYHIGH"
                                                    ) {
                                                        flagType = (
                                                            <OverlayTrigger
                                                                placement="right"
                                                                delay={{ show: 250, hide: 2000 }}
                                                                message={flagdata[0]?.message}
                                                                overlay={renderTooltip(
                                                                    flagdata[0]?.message,
                                                                    item,
                                                                )}
                                                            >
                                                                <img
                                                                    src={DemandScore_VeryHigh}
                                                                    alt=""
                                                                    style={{ height: "11px", width: "11px" }}
                                                                />
                                                            </OverlayTrigger>
                                                        );
                                                    } else if (
                                                        flagdata[0]?.demandtag
                                                            .toUpperCase()
                                                            .replaceAll(" ", "") === "VERYLOW"
                                                    ) {
                                                        flagType = (
                                                            <OverlayTrigger
                                                                placement="right"
                                                                delay={{ show: 250, hide: 2000 }}
                                                                message={flagdata[0]?.message}
                                                                overlay={renderTooltip(
                                                                    flagdata[0]?.message,
                                                                    item,
                                                                )}
                                                            >
                                                                <img
                                                                    src={DemandScore_VeryLow}
                                                                    alt=""
                                                                    style={{ height: "11px", width: "11px" }}
                                                                />
                                                            </OverlayTrigger>
                                                        );
                                                    }
                                                }

                                                if (flagdata[0]?.flag_value) {
                                                    flagvalue = flagdata[0]?.flag_value;
                                                }
                                            }
                                        }
                                        let STLY_ADR = 0;
                                        let STLY_OTB = 0;
                                        let STLY_Revenue = 0;
                                        let STLY_AVG_Lead_Time = 0;
                                        let STLY_AVG_Rate = 0;

                                        let LY_ADR = 0;
                                        let LY_OTB = 0;
                                        let LY_Revenue = 0;
                                        let LY_AVG_Lead_Time = 0;
                                        let LY_AVG_Rate = 0;

                                        if (
                                            STLY_LY_COMSET_Rates &&
                                            STLY_LY_COMSET_Rates.length > 0
                                        ) {
                                            let findByDate = STLY_LY_COMSET_Rates.filter(
                                                (x) =>
                                                    moment(x.dates).format("YYYY-MM-DD") ===
                                                    moment(item).format("YYYY-MM-DD"),
                                            );
                                            if (findByDate && findByDate.length > 0) {
                                                STLY_ADR = findByDate[0].stlyadr
                                                    ? findByDate[0].stlyadr
                                                    : 0;
                                                STLY_OTB = findByDate[0].stlyotb
                                                    ? findByDate[0].stlyotb
                                                    : 0;
                                                STLY_Revenue = findByDate[0].stlyrevenue
                                                    ? findByDate[0].stlyrevenue
                                                    : 0;
                                                STLY_AVG_Lead_Time = findByDate[0].stlyavgleadtime
                                                    ? findByDate[0].stlyavgleadtime
                                                    : 0;
                                                STLY_AVG_Rate = findByDate[0].stlyavgrate
                                                    ? findByDate[0].stlyavgrate
                                                    : 0;

                                                LY_ADR = findByDate[0].lyadr ? findByDate[0].lyadr : 0;
                                                LY_OTB = findByDate[0].lyotb ? findByDate[0].lyotb : 0;
                                                LY_Revenue = findByDate[0].lyrevenue
                                                    ? findByDate[0].lyrevenue
                                                    : 0;
                                                LY_AVG_Lead_Time = findByDate[0].lyavgleadtime
                                                    ? findByDate[0].lyavgleadtime
                                                    : 0;
                                                LY_AVG_Rate = findByDate[0].lyavgrate
                                                    ? findByDate[0].lyavgrate
                                                    : 0;

                                                if (STLY_ADR > 0) {
                                                    Total_STLY_ADR_Count = Total_STLY_ADR_Count + 1;
                                                    Total_STLY_ADR = Total_STLY_ADR + STLY_ADR;
                                                }

                                                if (STLY_AVG_Lead_Time > 0) {
                                                    Total_STLY_AVG_Lead_Time_Count =
                                                        Total_STLY_AVG_Lead_Time_Count + 1;
                                                    Total_STLY_AVG_Lead_Time =
                                                        Total_STLY_AVG_Lead_Time + STLY_AVG_Lead_Time;
                                                }

                                                Total_STLY_OTB = Total_STLY_OTB + STLY_OTB;
                                                Total_STLY_Revenue = Total_STLY_Revenue + STLY_Revenue;
                                                Total_STLY_AVG_Rate =
                                                    Total_STLY_AVG_Rate + STLY_AVG_Rate;

                                                if (LY_ADR > 0) {
                                                    Total_LY_ADR_Count = Total_LY_ADR_Count + 1;
                                                    Total_LY_ADR = Total_LY_ADR + LY_ADR;
                                                }

                                                if (LY_AVG_Lead_Time > 0) {
                                                    Total_LY_AVG_Lead_Time_Count =
                                                        Total_LY_AVG_Lead_Time_Count + 1;
                                                    Total_LY_AVG_Lead_Time =
                                                        Total_LY_AVG_Lead_Time + LY_AVG_Lead_Time;
                                                }

                                                Total_LY_OTB = Total_LY_OTB + LY_OTB;
                                                Total_LY_Revenue = Total_LY_Revenue + LY_Revenue;
                                                Total_LY_AVG_Rate = Total_LY_AVG_Rate + LY_AVG_Rate;
                                            }
                                        }

                                        const targetDate = moment(item).format("YYYY-MM-DD");

                                        return (
                                            <React.Fragment key={index}>
                                                <tr
                                                    key={index}
                                                    className={`${dayName ? "backgroundTr" : ""
                                                        } shadowOnHover`}
                                                >
                                                    <td className="">
                                                        <div className="d-flex gap-1">
                                                            {flagType ? (
                                                                flagType
                                                            ) : (
                                                                <div style={{ height: "11px", width: "11px" }}>
                                                                    {" "}
                                                                </div>
                                                            )}

                                                            <div className="d-flex gap-4">
                                                                {commonService.getDateInFormat(
                                                                    // startDateArrayRef.current[index]
                                                                    item,
                                                                )}{" "}
                                                                {moment(
                                                                    // new Date(startDateArrayRef.current[index]),
                                                                    new Date(item),
                                                                    "l",
                                                                ).format("ddd")}
                                                                <div className="d-flex justify-content-between align-items-center gap-2 ticketAlarmReload">
                                                                    {checkEvent?.length > 0 && (
                                                                        <img id={commonService.generateGlobalClickTrackerID("GroupWash", "ticket", item)}
                                                                            style={{ height: "11px", width: "11px" }}
                                                                            className="iconcolor"
                                                                            src={ticket}
                                                                            alt="ticket"
                                                                            onClick={() => {
                                                                                selectedEventDateRef.current = item;
                                                                                eventListPropsRef.current = checkEvent;
                                                                                setShowTicketModal(true);
                                                                            }}
                                                                        />
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    {/* <td className="width50 border-right text-center d-none">{flagvalue}</td> */}
                                                    <td className="width50 text-center">
                                                        {singleOTBData?.[0]?.dta
                                                            ? commonService.formateRoom(
                                                                singleOTBData?.[0]?.dta,
                                                            )
                                                            : 0}
                                                    </td>
                                                    <td className="width50 text-center">
                                                        {singleOTBData?.[0]?.inventory
                                                            ? commonService.formateRoom(
                                                                singleOTBData?.[0]?.inventory,
                                                            )
                                                            : 0}
                                                    </td>

                                                    <td className="text-center text-primary border-right">
                                                        <span id={commonService.generateGlobalClickTrackerID("GroupWash", "group-block-block", item)}
                                                            className={`cursorPointer ${selectedTdIndexRef.current === index
                                                                    ? "singleDateSummarySpan"
                                                                    : ""
                                                                }`}
                                                            onClick={(e) => {
                                                                singleDateSelectedDateRef.current = item;

                                                                handleGroupBtnClick(e);
                                                                selectedTdIndexRef.current = index;
                                                            }}
                                                        >
                                                            {singleOTBData?.[0]?.group_block
                                                                ? commonService.formateRoom(
                                                                    singleOTBData?.[0]?.group_block,
                                                                )
                                                                : 0}
                                                        </span>
                                                    </td>
                                                    <td className="text-center text-primary">
                                                        <span id={commonService.generateGlobalClickTrackerID("GroupWash", "group-block-confirm", item)}
                                                            className={`cursorPointer ${selectedTdIndexRef.current === index
                                                                    ? "singleDateSummarySpan"
                                                                    : ""
                                                                }`}
                                                            onClick={(e) => {
                                                                singleDateSelectedDateRef.current = item;
                                                                setRequestFor("GroupBlock_Confirm");
                                                                handleFilterBtnClick(e);
                                                                selectedTdIndexRef.current = index;
                                                            }}
                                                        >
                                                            {singleOTBData?.[0]?.group_otb
                                                                ? commonService.formateRoom(
                                                                    singleOTBData?.[0]?.group_otb,
                                                                )
                                                                : 0}
                                                        </span>
                                                    </td>
                                                    {/* <td className="text-center">
                            {singleOTBData?.[0]?.available_block
                              ? commonService.formateRoom(
                                  singleOTBData?.[0]?.available_block,
                                )
                              : 0}
                          </td> */}
                                                    <td className="text-end">
                                                        {singleOTBData?.[0]?.group_adr
                                                            ? commonService.formateAmount(
                                                                singleOTBData?.[0]?.group_adr,
                                                            )
                                                            : 0}
                                                    </td>
                                                    <td className="text-end">
                                                        {singleOTBData?.[0]?.group_revenue
                                                            ? commonService.formateAmount(
                                                                singleOTBData?.[0]?.group_revenue,
                                                            )
                                                            : 0}
                                                    </td>
                                                    <td className="text-center">
                                                        <span className={`groupwash-sys-wash-badge ${getWashClass(singleOTBData?.[0]?.system_wash_pct)}`}>
                                                            {singleOTBData?.[0]?.system_wash ?? 0} -{" "}
                                                            {singleOTBData?.[0]?.system_wash_pct ?? 0}%
                                                        </span>
                                                    </td>

                                                    {/* <td className="text-end width100"> */}
                                                    {/* <span>
                              {singleOTBData?.[0]?.user_wash_pct !==
                                undefined &&
                              singleOTBData?.[0]?.user_wash_pct !== ""
                                ? (() => {
                                    const groupOtb =
                                      singleOTBData?.[0]?.group_otb ?? 0;
                                    const userWashPct =
                                      singleOTBData?.[0]?.user_wash_pct ?? 0;
                                    const userWashRooms = Math.round(
                                      (userWashPct * groupOtb) / 100,
                                    );
                                    const systemWash =
                                      singleOTBData?.[0]?.system_wash ?? 0;
                                    const diff = userWashRooms - systemWash;
                                    const diffSign = diff >= 0 ? "+" : "";
                                    return (
                                      <div className="groupwash-validation-text">
                                        <span className="groupwash-validation-rms">
                                          {userWashRooms} rms
                                        </span>{" "}
                                        <br />
                                        <span className="groupwash-validation-variance">
                                          ({diffSign}
                                          {diff} vs sys)
                                        </span>
                                      </div>
                                    );
                                  })()
                                : null}
                            </span> */}
                                                    {/* </td> */}
                                                    <td className="text-end width100">
                                                        <div className="d-flex flex-column align-items-end justify-content-center">
                                                            <div className="d-flex align-items-center gap-2 justify-content-end">
                                                                <span>
                                                                    {singleOTBData?.[0]?.user_wash_pct !==
                                                                        undefined &&
                                                                        singleOTBData?.[0]?.user_wash_pct !== ""
                                                                        ? (() => {
                                                                            const groupBlock =
                                                                                singleOTBData?.[0]?.group_block ?? 0;
                                                                            const userWashPct =
                                                                                singleOTBData?.[0]?.user_wash_pct ??
                                                                                0;
                                                                            const userWashRooms = Math.round(
                                                                                (userWashPct * groupBlock) / 100,
                                                                            );
                                                                            const systemWash =
                                                                                singleOTBData?.[0]?.system_wash ?? 0;
                                                                            const diff = userWashRooms - systemWash;
                                                                            const diffSign = diff >= 0 ? "+" : "";
                                                                            return (
                                                                                <div className="groupwash-validation-text m-0">
                                                                                    <span className="groupwash-validation-rms">
                                                                                        {userWashRooms} rms
                                                                                    </span>{" "}
                                                                                    <br />
                                                                                    <span className="groupwash-validation-variance">
                                                                                        ({diffSign}
                                                                                        {diff} vs sys)
                                                                                    </span>
                                                                                </div>
                                                                            );
                                                                        })()
                                                                        : null}
                                                                </span>
                                                                <div className="position-relative groupwash-user-wash-container">
                                                                    <input id={commonService.generateGlobalClickTrackerID("GroupWash", "group-block-user-wash", item)}
                                                                        type="number"
                                                                        className="form-control user-wash-input"
                                                                        min="0"
                                                                        max="100"
                                                                        placeholder="0"
                                                                        value={
                                                                            singleOTBData?.[0]?.user_wash_pct ?? ""
                                                                        }
                                                                        onChange={(e) => {
                                                                            const rawValue = e.target.value;

                                                                            // 1. Determine the numeric value while handling empty inputs safely
                                                                            let finalValue = 0;
                                                                            if (rawValue !== "") {
                                                                                const parsed =
                                                                                    parseFloat(rawValue)?.toFixed(2);
                                                                                finalValue = isNaN(parsed)
                                                                                    ? 0
                                                                                    : Math.min(100, Math.max(0, parsed));
                                                                            }

                                                                            // 2. Format the target comparison date ONCE outside the loop to prevent lag
                                                                            // const targetDate =
                                                                            //   moment(item).format("YYYY-MM-DD");

                                                                            // 3. Update the state
                                                                            setOrgData((prev) =>
                                                                                prev.map((dataItem) =>
                                                                                    moment(dataItem.date).format(
                                                                                        "YYYY-MM-DD",
                                                                                    ) === targetDate
                                                                                        ? {
                                                                                            ...dataItem,
                                                                                            user_wash_pct: finalValue,
                                                                                        }
                                                                                        : dataItem,
                                                                                ),
                                                                            );
                                                                        }}
                                                                    />
                                                                    <span className="groupwash-pct-symbol">
                                                                        %
                                                                    </span>
                                                                </div>
                                                                {saveLoading.loading &&
                                                                    saveLoading.rowId === index ? (
                                                                    <span
                                                                        style={{ width: "16px", height: "16px" }}
                                                                    >
                                                                        <Spinner size="sm" />
                                                                    </span>
                                                                ) : (
                                                                    <img id={commonService.generateGlobalClickTrackerID("GroupWash", "save", item)}
                                                                        className="cursorPointer"
                                                                        src={saveIcon}
                                                                        title="Save"
                                                                        onClick={() => {
                                                                            let request = {
                                                                                propertycode:
                                                                                    propertyDetailFromRTK?.propertycode,
                                                                                staydate:
                                                                                    commonService?.getDateInDBFormat(
                                                                                        item,
                                                                                    ),
                                                                                userwashpct:
                                                                                    singleOTBData?.[0]?.user_wash_pct !==
                                                                                        ""
                                                                                        ? singleOTBData?.[0]?.user_wash_pct
                                                                                        : 0,
                                                                            };
                                                                            setSaveLoading({
                                                                                rowId: index,
                                                                                loading: true,
                                                                            });
                                                                            handleUpdateInputData(request);
                                                                        }}
                                                                        alt="Save"
                                                                        style={{ width: "16px", height: "16px" }}
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </td>

                                                    <td
                                                        className="perbackground text-center border-right"
                                                        value={singlePickupData?.[0]?.rms}
                                                        value={commonService.FindPercentageOfValueMaxUpTo100(singlePickupData?.[0]?.rms, singlePickupData?.[0]?.block)}

                                                    >
                                                        {singlePickupData?.[0]?.rms
                                                            ? commonService.formateRoom(
                                                                singlePickupData?.[0]?.rms,
                                                            )
                                                            : 0}/
                                                        {singlePickupData?.[0]?.block
                                                            ? commonService.formateRoom(
                                                                singlePickupData?.[0]?.block,
                                                            )
                                                            : 0}
                                                    </td>
                                                    <td
                                                        className={`perbackground text-center 
                              ${singlePickupData?.[0]?.rms < 0 ? "text-danger" : singlePickupData?.[0]?.rms > 0 ? "text-success" : ""}`}
                                                    >
                                                        {singlePickupData?.[0]?.rms
                                                            ? commonService.formateRoom(
                                                                singlePickupData?.[0]?.rms,
                                                            )
                                                            : 0}
                                                    </td>
                                                    <td className="text-end">
                                                        {singlePickupData?.[0]?.adr
                                                            ? commonService.formateAmount(
                                                                singlePickupData?.[0]?.adr,
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>
                                                    <td className="text-end">
                                                        {singlePickupData?.[0]?.rev
                                                            ? commonService.formateAmount(
                                                                parseFloat(singlePickupData?.[0]?.rev),
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>

                                                    <td
                                                        className="perbackground text-center border-right"
                                                        value={commonService.FindPercentageOfValueMaxUpTo100(threePickupData?.[0]?.rms, threePickupData?.[0]?.block)}
                                                    >
                                                        {threePickupData?.[0]?.rms
                                                            ? commonService.formateRoom(
                                                                threePickupData?.[0]?.rms,
                                                            )
                                                            : 0}/
                                                        {threePickupData?.[0]?.block
                                                            ? commonService.formateRoom(
                                                                threePickupData?.[0]?.block,
                                                            )
                                                            : 0}
                                                    </td>
                                                    <td
                                                        className={`perbackground text-center ${getDifferenceInfo(
                                                            threePickupData?.[0]?.rms,
                                                            singlePickupData?.[0]?.rms,
                                                        ).className
                                                            }`}
                                                    >
                                                        {commonService.formateRoom(
                                                            getDifferenceInfo(
                                                                threePickupData?.[0]?.rms,
                                                                singlePickupData?.[0]?.rms,
                                                            ).difference,
                                                        ) ?? 0}
                                                    </td>
                                                    <td className="text-end">
                                                        {threePickupData?.[0]?.adr
                                                            ? commonService.formateAmount(
                                                                threePickupData?.[0]?.adr,
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>
                                                    <td className="text-end">
                                                        {threePickupData?.[0]?.rev
                                                            ? commonService.formateAmount(
                                                                parseFloat(threePickupData?.[0]?.rev),
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>

                                                    <td
                                                        className="perbackground text-center border-right"
                                                        value={commonService.FindPercentageOfValueMaxUpTo100(sevenPickupData?.[0]?.rms, sevenPickupData?.[0]?.block)}
                                                    >
                                                        {sevenPickupData?.[0]?.rms
                                                            ? commonService.formateRoom(
                                                                sevenPickupData?.[0]?.rms,
                                                            )
                                                            : 0}
                                                        /
                                                        {sevenPickupData?.[0]?.block
                                                            ? commonService.formateRoom(
                                                                sevenPickupData?.[0]?.block,
                                                            )
                                                            : 0}
                                                    </td>
                                                    <td
                                                        className={`perbackground text-center ${getDifferenceInfo(
                                                            sevenPickupData?.[0]?.rms,
                                                            threePickupData?.[0]?.rms,
                                                        ).className
                                                            }`}
                                                    >
                                                        {commonService.formateRoom(
                                                            getDifferenceInfo(
                                                                sevenPickupData?.[0]?.rms,
                                                                threePickupData?.[0]?.rms,
                                                            ).difference,
                                                        ) ?? 0}
                                                    </td>
                                                    <td className="text-end">
                                                        {sevenPickupData?.[0]?.adr
                                                            ? commonService.formateAmount(
                                                                sevenPickupData?.[0]?.adr,
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>
                                                    <td className="text-end">
                                                        {sevenPickupData?.[0]?.rev
                                                            ? commonService.formateAmount(
                                                                parseFloat(sevenPickupData?.[0]?.rev),
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>

                                                    <td className="text-center text-primary border-right">
                                                        <span id={commonService.generateGlobalClickTrackerID("GroupWash", "transient-rms", item)}
                                                            className={`cursorPointer ${selectedTdIndexRef.current === index
                                                                    ? "singleDateSummarySpan"
                                                                    : ""
                                                                }`}
                                                            onClick={(e) => {
                                                                singleDateSelectedDateRef.current = item;
                                                                setRequestFor("Transient_RMS");
                                                                handleFilterBtnClick(e);
                                                                selectedTdIndexRef.current = index;
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            {singleOTBData?.[0]?.transient_otb
                                                                ? commonService.formateRoom(
                                                                    singleOTBData?.[0]?.transient_otb,
                                                                )
                                                                : 0}
                                                        </span>
                                                    </td>
                                                    <td className="text-end">
                                                        {singleOTBData?.[0]?.transient_adr
                                                            ? commonService.formateAmount(
                                                                singleOTBData?.[0]?.transient_adr,
                                                            )
                                                            : 0}
                                                    </td>
                                                    <td className="text-end">
                                                        {singleOTBData?.[0]?.transient_revenue
                                                            ? commonService.formateAmount(
                                                                singleOTBData?.[0]?.transient_revenue,
                                                            )
                                                            : 0}
                                                    </td>

                                                    <td className="text-primary text-center border-right">
                                                        <span id={commonService.generateGlobalClickTrackerID("GroupWash", "actual-on-books-rms", item)}
                                                            className={`cursorPointer ${selectedTdIndexRef.current === index
                                                                    ? "singleDateSummarySpan"
                                                                    : ""
                                                                }`}
                                                            onClick={(e) => {
                                                                singleDateSelectedDateRef.current = item;

                                                                handleFilterBtnClick(e);
                                                                selectedTdIndexRef.current = index;
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            {singleOTBData?.[0]?.total_otb
                                                                ? commonService.formateRoom(
                                                                    singleOTBData?.[0]?.total_otb,
                                                                )
                                                                : 0}
                                                        </span>
                                                    </td>

                                                    <td className="text-end">
                                                        {singleOTBData?.[0]?.total_adr
                                                            ? commonService.formateAmount(
                                                                singleOTBData?.[0]?.total_adr,
                                                            )
                                                            : 0}
                                                    </td>
                                                    <td className="text-end">
                                                        {singleOTBData?.[0]?.total_revenue
                                                            ? commonService.formateAmount(
                                                                singleOTBData?.[0]?.total_revenue,
                                                            )
                                                            : 0}
                                                    </td>

                                                    <td className="border-right text-center">
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            <lable id={commonService.generateGlobalClickTrackerID("GroupWash", "pricing-forecast", item)}
                                                                className={`${selectedForecast === "ema" && "cursor-pointer"} ${foreCastSpiderTextColor} ${forecastSpiderBorder} m-0`}
                                                                style={{ padding: "2px" }}
                                                                onClick={(e) => {
                                                                    if (selectedForecast !== "ema") {
                                                                        return e.preventDefault();
                                                                    }

                                                                    singleDateSelectedDateRef.current = item;
                                                                    handlePricingForecastBtnClick(e);
                                                                    selectedTdIndexRef.current = index;
                                                                }}
                                                            >
                                                                {singleForecastData?.[0]?.RMS
                                                                    ? commonService.formateRoom(
                                                                        singleForecastData?.[0]?.RMS,
                                                                    )
                                                                    : 0}
                                                            </lable>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {singleForecastData?.[0]?.R28AVG
                                                            ? commonService.formateRoom(
                                                                singleForecastData?.[0]?.R28AVG,
                                                            )
                                                            : 0}
                                                    </td>
                                                    <td className="text-end">
                                                        {singleForecastData?.[0]?.["Optimal Bar"]
                                                            ? `${commonService.formateAmount(
                                                                singleForecastData?.[0]?.["Optimal Bar"],
                                                            )}`
                                                            : `${commonService.formateAmount(0)}`}
                                                    </td>

                                                    {rateShopListData && (
                                                        <>
                                                            <td
                                                                className={`text-end border-right ${isSelfData?.[0]?.Rate < avgCompetitor
                                                                        ? "greenText"
                                                                        : "redText"
                                                                    }`}
                                                            >
                                                                {isSelfData?.length > 0 ? (
                                                                    <>
                                                                        {parseInt(isSelfData[0]?.RateStatusCode) ===
                                                                            201 ? (
                                                                            <img
                                                                                className="cursorPointer"
                                                                                src={soldOutIcon}
                                                                                alt="soldout"
                                                                            />
                                                                        ) : isSelfData[0]?.Rate ? (
                                                                            <span
                                                                                title={`${parseFloat(isSelfData[0]?.Rate) <= 0 && isSelfData[0]?.RateStatusDesc ? isSelfData[0]?.RateStatusDesc : ""}`}
                                                                            >{`${commonService.formateAmount(Math.round(isSelfData[0]?.Rate))}`}</span>
                                                                        ) : (
                                                                            <span
                                                                                title={`${isSelfData[0]?.RateStatusDesc ? isSelfData[0]?.RateStatusDesc : ""}`}
                                                                            >{`${commonService.formateAmount(0)}`}</span>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    commonService.formateAmount(0)
                                                                )}
                                                            </td>
                                                            <td
                                                                className={`text-end fontsize10px minwidth30px ${SelfDataRateDiff ? (SelfDataRateDiff > 0 ? "greenText" : "redText") : ""}`}
                                                            >
                                                                {SelfDataRateDiff
                                                                    ? commonService.formateAmount(
                                                                        SelfDataRateDiff,
                                                                    )
                                                                    : ""}
                                                            </td>
                                                        </>
                                                    )}
                                                    {rateShopListData && (
                                                        <>
                                                            <td id={commonService.generateGlobalClickTrackerID("GroupWash", "compset-avg-click", item)}
                                                                className="text-end cursorPointer border-right"
                                                                onClick={() => {
                                                                    setClickedDate(item);
                                                                    setToolsSummaryModal(true);
                                                                }}
                                                            >
                                                                {avgCompetitor
                                                                    ? `${commonService.formateAmount(
                                                                        avgCompetitor,
                                                                    )}`
                                                                    : `${commonService.formateAmount(0)}`}
                                                            </td>
                                                            <td
                                                                className={`text-end fontsize10px minwidth30px ${avgCompetitorRateDiff ? (avgCompetitorRateDiff > 0 ? "greenText" : "redText") : ""}`}
                                                            >
                                                                {avgCompetitorRateDiff
                                                                    ? commonService.formateAmount(
                                                                        avgCompetitorRateDiff,
                                                                    )
                                                                    : ""}
                                                            </td>
                                                            <td className="text-end">
                                                                {commonService.formateAmount(STLY_AVG_Rate)}
                                                            </td>
                                                            <td className="text-end border-end">
                                                                {commonService.formateAmount(LY_AVG_Rate)}
                                                            </td>
                                                        </>
                                                    )}
                                                    {dataExistsOrNot?.length > 0
                                                        ? rateShopListData?.map((x) => {
                                                            if (
                                                                x.CheckInDate ===
                                                                moment(item).format("YYYY-MM-DD") &&
                                                                x.IsSelf === false
                                                            ) {
                                                                let RateDiff = 0;
                                                                let pd = past_rateShopListData.filter(
                                                                    (px) =>
                                                                        px.CheckInDate ===
                                                                        moment(item).format("YYYY-MM-DD") &&
                                                                        (px.IsSelf === false) &
                                                                        (px.CompetitorID === x.CompetitorID),
                                                                );
                                                                if (pd && pd.length > 0) {
                                                                    let PDRate = pd[0]?.Rate ? pd[0]?.Rate : 0;
                                                                    let Rate = x?.Rate ? x?.Rate : 0;
                                                                    RateDiff =
                                                                        parseInt(PDRate) - parseInt(Rate);
                                                                }

                                                                return (
                                                                    <>
                                                                        {parseInt(x?.RateStatusCode) === 201 ? (
                                                                            <td className="text-end">
                                                                                <img
                                                                                    className="cursorPointer"
                                                                                    src={soldOutIcon}
                                                                                    alt="soldout"
                                                                                />
                                                                            </td>
                                                                        ) : (
                                                                            <td className="text-end">
                                                                                {x?.Rate ? (
                                                                                    <span
                                                                                        title={`${parseFloat(x?.Rate) <= 0 && x?.RateStatusDesc ? x?.RateStatusDesc : ""}`}
                                                                                    >{`${commonService.formateAmount(Math.round(x?.Rate))}`}</span>
                                                                                ) : (
                                                                                    <span
                                                                                        title={`${x?.RateStatusDesc ? x?.RateStatusDesc : ""}`}
                                                                                    >{`${commonService.formateAmount(0)}`}</span>
                                                                                )}
                                                                            </td>
                                                                        )}
                                                                        <td
                                                                            className={`text-end fontsize10px minwidth30px ${RateDiff ? (RateDiff > 0 ? "greenText" : "redText") : ""}`}
                                                                        >
                                                                            {RateDiff
                                                                                ? commonService.formateAmount(
                                                                                    RateDiff,
                                                                                )
                                                                                : ""}
                                                                        </td>
                                                                    </>
                                                                );
                                                            }
                                                        })
                                                        : rateShopListData?.map((x, index) => {
                                                            if (
                                                                x.CheckInDate ===
                                                                moment(
                                                                    rateShopListData?.[0]?.CheckInDate,
                                                                ).format("YYYY-MM-DD") &&
                                                                x.IsSelf === false
                                                            ) {
                                                                let RateDiff = 0;
                                                                let pd = past_rateShopListData.filter(
                                                                    (px) =>
                                                                        px.CheckInDate ===
                                                                        moment(item).format("YYYY-MM-DD") &&
                                                                        (px.IsSelf === false) &
                                                                        (px.CompetitorID === x.CompetitorID),
                                                                );
                                                                if (pd && pd.length > 0) {
                                                                    let PDRate = pd[0]?.Rate ? pd[0]?.Rate : 0;
                                                                    let Rate = x?.Rate ? x?.Rate : 0;
                                                                    RateDiff =
                                                                        parseInt(PDRate) - parseInt(Rate);
                                                                }

                                                                return (
                                                                    <>
                                                                        <td className="text-end">$0</td>{" "}
                                                                        <td
                                                                            className={`text-end fontsize10px minwidth30px ${RateDiff ? (RateDiff > 0 ? "greenText" : "redText") : ""}`}
                                                                        >
                                                                            {RateDiff
                                                                                ? commonService.formateAmount(
                                                                                    RateDiff,
                                                                                )
                                                                                : ""}
                                                                        </td>
                                                                    </>
                                                                );
                                                            }
                                                        })}

                                                    <td className="border-right">
                                                        <div>
                                                            {checkNoteExists?.length > 0 ? (
                                                                <img id={commonService.generateGlobalClickTrackerID("GroupWash", "darkNoteIcon", item)}
                                                                    className="cursorPointer"
                                                                    src={darkNoteIcon}
                                                                    onClick={() => {
                                                                        clickedDateForNote.current = item;
                                                                        setShowNoteSidebar(true);
                                                                    }}
                                                                    alt="note"
                                                                />
                                                            ) : (
                                                                <img id={commonService.generateGlobalClickTrackerID("GroupWash", "note", item)}
                                                                    className="cursorPointer"
                                                                    src={NoteIcon}
                                                                    onClick={() => {
                                                                        clickedDateForNote.current = item;
                                                                        setShowNoteSidebar(true);
                                                                    }}
                                                                    alt="note"
                                                                />
                                                            )}

                                                            <div style={{ display: "none" }}>
                                                                {checkNoteExists?.map((item, index) => {
                                                                    return (
                                                                        <>
                                                                            <span>{`${item?.displayname
                                                                                } - ${htmlToText(
                                                                                    item?.widgetnotes,
                                                                                )}`}</span>{" "}
                                                                            <br />
                                                                        </>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>

                                                {index === startDateArrayRef.current?.length - 1 && (
                                                    <tr className="shadowOnHover">
                                                        <td className="boldTd" colSpan={2}>
                                                            Total Nights - (
                                                            {startDateArrayRef?.current?.length || 0})
                                                        </td>
                                                        <td className="boldTd text-center">
                                                            {commonService.formateRoom(Total_ActualInventory)}
                                                        </td>

                                                        <td className="boldTd border-right text-center">
                                                            {commonService.formateRoom(Total_GRP_Block)}
                                                        </td>
                                                        <td className="boldTd text-center">
                                                            {" "}
                                                            {commonService.formateRoom(
                                                                Total_GRP_Confirm,
                                                            )}{" "}
                                                        </td>
                                                        {/* <td className="boldTd text-center">
                              {" "}
                              {commonService.formateRoom(
                                Total_GRP_Avail_Block,
                              )}{" "}
                            </td> */}
                                                        <td className="boldTd"></td>
                                                        <td className="boldTd text-end">
                                                            {" "}
                                                            {commonService.formateAmount(Total_GRP_Rev)}{" "}
                                                        </td>
                                                        <td className="boldTd text-center">
                                                            {" "}
                                                            {commonService.formateRoom(Total_GRP_SysWash)} RMS
                                                        </td>
                                                        {/* <td className="boldTd"></td> */}
                                                        <td className="boldTd ps-3">
                                                            {" "}
                                                            {commonService.formateRoom(
                                                                Total_GRP_UserWash,
                                                            )}{" "}
                                                            RMS
                                                        </td>

                                                        {/* 1 Day Pickup */}
                                                        <td className="boldTd text-center border-right">
                                                            {commonService.formateRoom(
                                                                pickupFromDataTotal?.pick_rms,
                                                            )}/
                                                            {commonService.formateRoom(
                                                                pickupFromDataTotal?.pickup_block,
                                                            )}
                                                        </td>
                                                        <td className="boldTd"></td>
                                                        <td className="boldTd text-end">
                                                            {commonService.formateAmount(
                                                                pickupFromDataTotal?.pick_adr,
                                                            )}
                                                        </td>
                                                        <td className="boldTd text-end">
                                                            {commonService.formateAmount(
                                                                pickupFromDataTotal?.pick_rev,
                                                            )}
                                                        </td>

                                                        {/* 3 Day Pickup */}
                                                        <td className="boldTd text-center border-right">
                                                            {commonService.formateRoom(
                                                                threePickupFromDataTotal?.pick_rms,
                                                            )}/
                                                            {commonService.formateRoom(
                                                                threePickupFromDataTotal?.pickup_block,
                                                            )}
                                                        </td>
                                                        <td className="boldTd"></td>
                                                        <td className="boldTd text-end">
                                                            {commonService.formateAmount(
                                                                threePickupFromDataTotal?.pick_adr,
                                                            )}
                                                        </td>
                                                        <td className="boldTd text-end">
                                                            {commonService.formateAmount(
                                                                threePickupFromDataTotal?.pick_rev,
                                                            )}
                                                        </td>

                                                        {/* 7 Day Pickup */}
                                                        <td className="boldTd text-center border-right">
                                                            {commonService.formateRoom(
                                                                sevenPickupFromDataTotal?.pick_rms,
                                                            )}/
                                                            {commonService.formateRoom(
                                                                sevenPickupFromDataTotal?.pickup_block,
                                                            )}
                                                        </td>
                                                        <td className="boldTd"></td>
                                                        <td className="boldTd text-end">
                                                            {commonService.formateAmount(
                                                                sevenPickupFromDataTotal?.pick_adr,
                                                            )}
                                                        </td>
                                                        <td className="boldTd text-end">
                                                            {commonService.formateAmount(
                                                                sevenPickupFromDataTotal?.pick_rev,
                                                            )}
                                                        </td>

                                                        <td className="boldTd border-right text-center">
                                                            {commonService.formateRoom(Total_TRA_Rms)}
                                                        </td>
                                                        <td className="boldTd"> </td>
                                                        <td className="boldTd text-end">
                                                            {commonService.formateAmount(Total_TRA_Rev)}
                                                        </td>

                                                        <td className="boldTd border-right text-center">
                                                            {commonService.formateRoom(Total_AOB_Rms)}
                                                        </td>
                                                        <td className="boldTd"> </td>
                                                        <td className="boldTd text-end">
                                                            {commonService.formateAmount(Total_AOB_Rev)}
                                                        </td>

                                                        <td className="boldTd border-right"></td>
                                                        <td className="boldTd"></td>
                                                        <td className="boldTd"></td>
                                                        <td className="boldTd"></td>
                                                        <td className="boldTd"></td>
                                                        {rateShopListData && (
                                                            <>
                                                                {" "}
                                                                <td className="boldTd"></td>
                                                                <td className="boldTd"></td>
                                                                <td className="boldTd"></td>
                                                                <td className="boldTd"></td>
                                                                <td className="boldTd"></td>
                                                                <td className="boldTd"></td>
                                                            </>
                                                        )}
                                                        <td className="boldTd"></td>
                                                    </tr>
                                                )}
                                            </React.Fragment>
                                        );
                                    })
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
                {showTicketModal && (
                    <EventViewModal
                        showModal={showTicketModal}
                        closeModal={closeTicketModal}
                        eventDetails={eventListPropsRef.current}
                        selectedDate={selectedEventDateRef.current}
                        getEventList={getEventList}
                    />
                )}
            </div>
            {api !== 0 && <Comments widgetDetails={para} editorId={"GroupWash"} />}

            <GroupWashChart
                groupWashData={orgData || []}
                oneDaypickupFromData={pickupFromData || []}
                threeDayPickupFromData={threePickupFromData || []}
                sevenDayPickupFromData={sevenPickupFromData || []}
                isLoading={chartLoading}
            />

            <Overlay
                show={ONTHEBOOKS.IsDisplay}
                target={ONTHEBOOKS.Target}
                placement={ONTHEBOOKS.Position}
                rootClose={true}
                onHide={closeSingleDate}
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain groupwash-modal-overlay"
                >
                    <div className="horizontal-menu-option active">
                        <SingleDateSummaryModal
                            requestFor={requestFor}
                            closeModal={closeSingleDate}
                            asOfDate={selectAsOfDate ? selectAsOfDate : para?.asOfDate}
                            selectedDate={singleDateSelectedDateRef.current}
                            // pickupDate={
                            //   selectPickupDate
                            //     ? selectPickupDate
                            //     : singleDatePickupDateRef.current
                            // }
                            pickupDate={
                                selectSevenPickupDate
                                    ? selectSevenPickupDate
                                    : sevenMaxDateRef.current
                            }
                            propertyDetail={{ propertyCode: para?.propertyCode }}
                        />
                    </div>
                </Popover>
            </Overlay>

            <Overlay
                show={groupModal.IsDisplay}
                target={groupModal.Target}
                placement={groupModal.Position}
                rootClose={true}
                onHide={closeGroupDate}
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain"
                >
                    <div className="horizontal-menu-option active singleDayGroupSummary">
                        <SingleDayGroupModal
                            closeModal={closeGroupDate}
                            asOfDate={selectAsOfDate ? selectAsOfDate : para?.asOfDate}
                            selectedDate={singleDateSelectedDateRef.current}
                            propertyCode={propertyCode}
                        />
                    </div>
                </Popover>
            </Overlay>

            {/* Overlay for Pricing & Forecast > System Forcast */}
            <Overlay
                show={pricingForcastModal.IsDisplay}
                target={pricingForcastModal.Target}
                placement={pricingForcastModal.Position}
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain"
                >
                    <div className="horizontal-menu-option active singleDayGroupSummary">
                        <SingleDayPricingForcastModal
                            closeModal={closePricingForecastDate}
                            asOfDate={selectAsOfDate ? selectAsOfDate : para?.asOfDate}
                            selectedDate={singleDateSelectedDateRef.current}
                            propertyCode={propertyCode}
                        />
                    </div>
                </Popover>
            </Overlay>

            {showNoteSidebar && (
                <WidgetNote
                    show={showNoteSidebar}
                    handleClose={closeNoteSideBar}
                    // widgetId={para?.widgetId}
                    widgetId={0}
                    propertyId={propertyDetailFromRTK?.propertyid}
                    rowTitle={para?.rowTitle}
                    dateForNote={clickedDateForNote.current}
                />
            )}
            {addNoteModal && (
                <AddWidgetModal
                    showModal={addNoteModal}
                    closeModal={closeNoteModal}
                    // widgetId={para?.widgetId}
                    widgetId={0}
                    propertyId={propertyDetailFromRTK?.propertyid}
                    rowTitle={para?.rowTitle}
                />
            )}
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}
            {flagModal && (
                <FlagPopup
                    showModal={flagModal}
                    closeModal={() => setFlagModal(false)}
                    data={flagModalData}
                />
            )}
            {showToolsSummaryModal && (
                <ToolsSummaryModal
                    showToolsSummaryModal={showToolsSummaryModal}
                    closeToolsSummaryModal={closeToolsSummaryModal}
                    selectedDate={ClickedDate}
                    propertyDetail={propertyDetailFromRTK}
                />
            )}
        </div>
    );
};

export default GroupWash;
